import * as i0 from '@angular/core';
import { inject, ChangeDetectorRef, DestroyRef, EventEmitter, ElementRef, booleanAttribute, ViewChild, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, Directive, Renderer2, Injectable, NgZone, ViewChildren, TemplateRef, ContentChild, ContentChildren, NgModule } from '@angular/core';
import { __esDecorate, __runInitializers } from 'tslib';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WithConfig, NzConfigService, onConfigChangeEventForComponent } from 'ng-zorro-antd/core/config';
import { fromEventOutsideAngular, arraysEqual, isNil, measureScrollbar } from 'ng-zorro-antd/core/util';
import * as i4 from 'ng-zorro-antd/dropdown';
import { NzDropDownModule, NzDropDownDirective } from 'ng-zorro-antd/dropdown';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from 'ng-zorro-antd/button';
import { NzButtonModule } from 'ng-zorro-antd/button';
import * as i4$1 from 'ng-zorro-antd/checkbox';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import * as i1 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzRadioComponent } from 'ng-zorro-antd/radio';
import * as i2 from 'ng-zorro-antd/menu';
import * as i7 from 'ng-zorro-antd/core/transition-patch';
import * as i8 from 'ng-zorro-antd/core/wave';
import { Subject, ReplaySubject, BehaviorSubject, combineLatest, merge, EMPTY, of } from 'rxjs';
import { map, distinctUntilChanged, debounceTime, skip, filter, switchMap, startWith, delay, mergeMap } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import * as i1$2 from '@angular/cdk/scrolling';
import { ScrollingModule, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { NzResizeService } from 'ng-zorro-antd/core/services';
import * as i1$1 from 'ng-zorro-antd/empty';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzResizeObserver } from 'ng-zorro-antd/cdk/resize-observer';
import { Directionality } from '@angular/cdk/bidi';
import * as i1$4 from 'ng-zorro-antd/pagination';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import * as i1$3 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
const _c0 = ["*"];
const _forTrack0 = ($index, $item) => $item.value;
function NzTableFilterComponent_ng_template_1_Template(rf, ctx) {}
function NzTableFilterComponent_Conditional_2_For_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 14);
    i0.ɵɵlistener("ngModelChange", function NzTableFilterComponent_Conditional_2_For_7_Conditional_1_Template_label_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const f_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.check(f_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngModel", f_r4.checked);
  }
}
function NzTableFilterComponent_Conditional_2_For_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵlistener("ngModelChange", function NzTableFilterComponent_Conditional_2_For_7_Conditional_2_Template_label_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const f_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.check(f_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngModel", f_r4.checked);
  }
}
function NzTableFilterComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("click", function NzTableFilterComponent_Conditional_2_For_7_Template_li_click_0_listener() {
      const f_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.check(f_r4));
    });
    i0.ɵɵconditionalCreate(1, NzTableFilterComponent_Conditional_2_For_7_Conditional_1_Template, 1, 1, "label", 12)(2, NzTableFilterComponent_Conditional_2_For_7_Conditional_2_Template, 1, 1, "label", 13);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("nzSelected", f_r4.checked);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.filterMultiple ? 1 : 2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(f_r4.text);
  }
}
function NzTableFilterComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-filter-trigger", 3);
    i0.ɵɵlistener("nzVisibleChange", function NzTableFilterComponent_Conditional_2_Template_nz_filter_trigger_nzVisibleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onVisibleChange($event));
    });
    i0.ɵɵelement(1, "nz-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "nz-dropdown-menu", null, 0)(4, "div", 5)(5, "ul", 6);
    i0.ɵɵrepeaterCreate(6, NzTableFilterComponent_Conditional_2_For_7_Template, 5, 3, "li", 7, _forTrack0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 8)(9, "button", 9);
    i0.ɵɵlistener("click", function NzTableFilterComponent_Conditional_2_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.reset());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 10);
    i0.ɵɵlistener("click", function NzTableFilterComponent_Conditional_2_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const filterMenu_r7 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzVisible", ctx_r1.isVisible)("nzActive", ctx_r1.isChecked)("nzDropdownMenu", filterMenu_r7);
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r1.listOfParsedFilter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r1.isChecked);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale.filterReset, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.locale.filterConfirm);
  }
}
function NzTableFilterComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.extraTemplate);
  }
}
function NzTableSelectionComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵlistener("ngModelChange", function NzTableSelectionComponent_Conditional_0_Template_label_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCheckedChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ant-table-selection-select-all-custom", ctx_r1.showRowSelection);
    i0.ɵɵproperty("ngModel", ctx_r1.checked)("nzDisabled", ctx_r1.disabled)("nzIndeterminate", ctx_r1.indeterminate);
    i0.ɵɵattribute("aria-label", ctx_r1.label);
  }
}
function NzTableSelectionComponent_Conditional_1_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵlistener("click", function NzTableSelectionComponent_Conditional_1_For_7_Template_li_click_0_listener() {
      const selection_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      return i0.ɵɵresetView(selection_r4.onSelect());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selection_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selection_r4.text, " ");
  }
}
function NzTableSelectionComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 4);
    i0.ɵɵelement(2, "nz-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "nz-dropdown-menu", null, 0)(5, "ul", 6);
    i0.ɵɵrepeaterCreate(6, NzTableSelectionComponent_Conditional_1_For_7_Template, 2, 1, "li", 7, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const selectionMenu_r5 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzDropdownMenu", selectionMenu_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.listOfSelections);
  }
}
function NzTableSortersComponent_ng_template_1_Template(rf, ctx) {}
function NzTableSortersComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-icon", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r0.sortOrder === "ascend");
  }
}
function NzTableSortersComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-icon", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r0.sortOrder === "descend");
  }
}
const _c1 = ["nzChecked", ""];
function NzTdAddOnComponent_Conditional_0_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NzTdAddOnComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTdAddOnComponent_Conditional_0_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.nzExpandIcon);
  }
}
function NzTdAddOnComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("expandChange", function NzTdAddOnComponent_Conditional_0_Conditional_2_Template_button_expandChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onExpandChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("expand", ctx_r0.nzExpand)("spaceMode", !ctx_r0.nzShowExpand);
  }
}
function NzTdAddOnComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-row-indent", 1);
    i0.ɵɵconditionalCreate(1, NzTdAddOnComponent_Conditional_0_Conditional_1_Template, 1, 1, null, 2)(2, NzTdAddOnComponent_Conditional_0_Conditional_2_Template, 1, 2, "button", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("indentSize", ctx_r0.nzIndentSize);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.nzExpandIcon ? 1 : 2);
  }
}
function NzTdAddOnComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵlistener("ngModelChange", function NzTdAddOnComponent_Conditional_1_Template_label_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onCheckedChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzDisabled", ctx_r0.nzDisabled)("ngModel", ctx_r0.nzChecked)("nzIndeterminate", ctx_r0.nzIndeterminate);
    i0.ɵɵattribute("aria-label", ctx_r0.nzLabel);
  }
}
const _c2 = ["nzColumnKey", ""];
const _c3 = [[["", "nz-th-extra", ""]], [["nz-filter-trigger"]], "*"];
const _c4 = ["[nz-th-extra]", "nz-filter-trigger", "*"];
function NzThAddOnComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-table-filter", 6);
    i0.ɵɵlistener("filterChange", function NzThAddOnComponent_Conditional_0_Template_nz_table_filter_filterChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFilterValueChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const notFilterTemplate_r3 = i0.ɵɵreference(3);
    const extraTemplate_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("contentTemplate", notFilterTemplate_r3)("extraTemplate", extraTemplate_r4)("customFilter", ctx_r1.nzCustomFilter)("filterMultiple", ctx_r1.nzFilterMultiple)("listOfFilter", ctx_r1.nzFilters);
  }
}
function NzThAddOnComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const notFilterTemplate_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", notFilterTemplate_r3);
  }
}
function NzThAddOnComponent_ng_template_2_ng_template_0_Template(rf, ctx) {}
function NzThAddOnComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzThAddOnComponent_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const sortTemplate_r5 = i0.ɵɵreference(7);
    const contentTemplate_r6 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.nzShowSort ? sortTemplate_r5 : contentTemplate_r6);
  }
}
function NzThAddOnComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵprojection(1, 1);
  }
}
function NzThAddOnComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-table-sorters", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const contentTemplate_r6 = i0.ɵɵreference(9);
    i0.ɵɵproperty("sortOrder", ctx_r1.sortOrder)("sortDirections", ctx_r1.sortDirections)("contentTemplate", contentTemplate_r6);
  }
}
function NzThAddOnComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
const _c5 = ["nzSelections", ""];
const _c6 = ["nz-table-content", ""];
function NzTableContentComponent_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "col");
  }
  if (rf & 2) {
    const width_r1 = ctx.$implicit;
    i0.ɵɵstyleProp("width", width_r1)("min-width", width_r1);
  }
}
function NzTableContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "colgroup");
    i0.ɵɵrepeaterCreate(1, NzTableContentComponent_Conditional_0_For_2_Template, 1, 4, "col", 3, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.listOfColWidth);
  }
}
function NzTableContentComponent_Conditional_1_ng_template_1_Template(rf, ctx) {}
function NzTableContentComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 0);
    i0.ɵɵtemplate(1, NzTableContentComponent_Conditional_1_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.theadTemplate);
  }
}
function NzTableContentComponent_ng_template_2_Template(rf, ctx) {}
function NzTableContentComponent_Conditional_4_ng_template_1_Template(rf, ctx) {}
function NzTableContentComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tfoot", 2);
    i0.ɵɵtemplate(1, NzTableContentComponent_Conditional_4_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tfootTemplate);
  }
}
const _c7 = ["tdElement"];
const _c8 = ["nz-table-fixed-row", ""];
function NzTableFixedRowComponent_Conditional_2_ng_template_2_Template(rf, ctx) {}
function NzTableFixedRowComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, NzTableFixedRowComponent_Conditional_2_ng_template_2_Template, 0, 0, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const contentTemplate_r2 = i0.ɵɵreference(6);
    i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(1, 3, ctx_r0.hostWidth$), "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r2);
  }
}
function NzTableFixedRowComponent_Conditional_4_ng_template_0_Template(rf, ctx) {}
function NzTableFixedRowComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTableFixedRowComponent_Conditional_4_ng_template_0_Template, 0, 0, "ng-template", 4);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTemplate_r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r2);
  }
}
function NzTableFixedRowComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c9 = ["nz-table-measure-row", ""];
function NzTrMeasureComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 1, 0);
  }
}
function NzTbodyComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 2);
    i0.ɵɵlistener("listOfAutoWidth", function NzTbodyComponent_Conditional_0_Conditional_0_Template_tr_listOfAutoWidth_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onListOfAutoWidthChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const listOfMeasureColumn_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listOfMeasureColumn", listOfMeasureColumn_r3);
  }
}
function NzTbodyComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, NzTbodyComponent_Conditional_0_Conditional_0_Template, 1, 1, "tr", 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.isInsideTable && ctx.length ? 0 : -1);
  }
}
function NzTbodyComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 0);
    i0.ɵɵelement(1, "nz-embed-empty", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("specificContent", i0.ɵɵpipeBind1(2, 1, ctx_r1.noResult$));
  }
}
const _c10 = ["tableHeaderElement"];
const _c11 = ["tableBodyElement"];
const _c12 = ["tableFootElement"];
const _c13 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function NzTableInnerScrollComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9, 1);
    i0.ɵɵelement(2, "table", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r0.bodyStyleMap);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("scrollX", ctx_r0.scrollX)("listOfColWidth", ctx_r0.listOfColWidth)("contentTemplate", ctx_r0.contentTemplate);
  }
}
function NzTableInnerScrollComponent_Conditional_0_Conditional_4_ng_container_4_ng_template_1_Template(rf, ctx) {}
function NzTableInnerScrollComponent_Conditional_0_Conditional_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NzTableInnerScrollComponent_Conditional_0_Conditional_4_ng_container_4_ng_template_1_Template, 0, 0, "ng-template", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.virtualTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c13, item_r2, i_r3));
  }
}
function NzTableInnerScrollComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 11, 1)(2, "table", 12)(3, "tbody");
    i0.ɵɵtemplate(4, NzTableInnerScrollComponent_Conditional_0_Conditional_4_ng_container_4_Template, 2, 5, "ng-container", 13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r0.data.length ? ctx_r0.scrollY : ctx_r0.noDataVirtualHeight);
    i0.ɵɵproperty("itemSize", ctx_r0.virtualItemSize)("maxBufferPx", ctx_r0.virtualMaxBufferPx)("minBufferPx", ctx_r0.virtualMinBufferPx);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("scrollX", ctx_r0.scrollX)("listOfColWidth", ctx_r0.listOfColWidth);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r0.data)("cdkVirtualForTrackBy", ctx_r0.virtualForTrackBy);
  }
}
function NzTableInnerScrollComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15, 2);
    i0.ɵɵelement(2, "table", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r0.headerStyleMap);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("scrollX", ctx_r0.scrollX)("listOfColWidth", ctx_r0.listOfColWidth)("tfootTemplate", ctx_r0.tfootTemplate);
  }
}
function NzTableInnerScrollComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4, 0);
    i0.ɵɵelement(2, "table", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, NzTableInnerScrollComponent_Conditional_0_Conditional_3_Template, 3, 5, "div", 6)(4, NzTableInnerScrollComponent_Conditional_0_Conditional_4_Template, 5, 9, "cdk-virtual-scroll-viewport", 7);
    i0.ɵɵconditionalCreate(5, NzTableInnerScrollComponent_Conditional_0_Conditional_5_Template, 3, 5, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.headerStyleMap);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("scrollX", ctx_r0.scrollX)("listOfColWidth", ctx_r0.listOfColWidth)("theadTemplate", ctx_r0.theadTemplate)("tfootTemplate", ctx_r0.tfootFixed === "top" ? ctx_r0.tfootTemplate : null);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.virtualTemplate ? 3 : 4);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.tfootFixed === "bottom" ? 5 : -1);
  }
}
function NzTableInnerScrollComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17, 1);
    i0.ɵɵelement(2, "table", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.bodyStyleMap);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("scrollX", ctx_r0.scrollX)("listOfColWidth", ctx_r0.listOfColWidth)("theadTemplate", ctx_r0.theadTemplate)("contentTemplate", ctx_r0.contentTemplate)("tfootTemplate", ctx_r0.tfootTemplate);
  }
}
function NzTableTitleFooterComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function NzTableTitleFooterComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.footer);
  }
}
function NzTableComponent_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NzTableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTableComponent_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 4);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const paginationTemplate_r1 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", paginationTemplate_r1);
  }
}
function NzTableComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-table-title-footer", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.nzTitle);
  }
}
function NzTableComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-table-inner-scroll", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const tableMainElement_r3 = i0.ɵɵreference(3);
    const contentTemplate_r4 = i0.ɵɵreference(12);
    i0.ɵɵproperty("data", ctx_r1.data)("scrollX", ctx_r1.scrollX)("scrollY", ctx_r1.scrollY)("contentTemplate", contentTemplate_r4)("listOfColWidth", ctx_r1.listOfAutoColWidth)("theadTemplate", ctx_r1.theadTemplate)("tfootTemplate", ctx_r1.tfootTemplate)("tfootFixed", ctx_r1.tfootFixed)("verticalScrollBarWidth", ctx_r1.verticalScrollBarWidth)("virtualTemplate", ctx_r1.nzVirtualScrollDirective ? ctx_r1.nzVirtualScrollDirective.templateRef : null)("virtualItemSize", ctx_r1.nzVirtualItemSize)("virtualMaxBufferPx", ctx_r1.nzVirtualMaxBufferPx)("virtualMinBufferPx", ctx_r1.nzVirtualMinBufferPx)("tableMainElement", tableMainElement_r3)("virtualForTrackBy", ctx_r1.nzVirtualForTrackBy)("noDataVirtualHeight", ctx_r1.noDataVirtualHeight);
  }
}
function NzTableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-table-inner-default", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const contentTemplate_r4 = i0.ɵɵreference(12);
    i0.ɵɵproperty("tableLayout", ctx_r1.nzTableLayout)("listOfColWidth", ctx_r1.listOfManualColWidth)("theadTemplate", ctx_r1.theadTemplate)("contentTemplate", contentTemplate_r4)("tfootTemplate", ctx_r1.tfootTemplate);
  }
}
function NzTableComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-table-title-footer", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("footer", ctx_r1.nzFooter);
  }
}
function NzTableComponent_Conditional_8_ng_template_0_Template(rf, ctx) {}
function NzTableComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTableComponent_Conditional_8_ng_template_0_Template, 0, 0, "ng-template", 4);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const paginationTemplate_r1 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", paginationTemplate_r1);
  }
}
function NzTableComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-pagination", 11);
    i0.ɵɵlistener("nzPageSizeChange", function NzTableComponent_ng_template_9_Conditional_0_Template_nz_pagination_nzPageSizeChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPageSizeChange($event));
    })("nzPageIndexChange", function NzTableComponent_ng_template_9_Conditional_0_Template_nz_pagination_nzPageIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPageIndexChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", !ctx_r1.showPagination)("nzShowSizeChanger", ctx_r1.nzShowSizeChanger)("nzPageSizeOptions", ctx_r1.nzPageSizeOptions)("nzItemRender", ctx_r1.nzItemRender)("nzShowQuickJumper", ctx_r1.nzShowQuickJumper)("nzHideOnSinglePage", ctx_r1.nzHideOnSinglePage)("nzShowTotal", ctx_r1.nzShowTotal)("nzSize", ctx_r1.nzPaginationType === "small" ? "small" : ctx_r1.nzSize === "default" ? "default" : "small")("nzPageSize", ctx_r1.nzPageSize)("nzTotal", ctx_r1.nzTotal)("nzSimple", ctx_r1.nzSimple)("nzPageIndex", ctx_r1.nzPageIndex);
  }
}
function NzTableComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, NzTableComponent_ng_template_9_Conditional_0_Template, 1, 12, "nz-pagination", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.nzShowPagination && ctx_r1.data.length ? 0 : -1);
  }
}
function NzTableComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c14 = ["contentTemplate"];
const _c15 = ["nzSummary", ""];
function NzTfootSummaryComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function NzTfootSummaryComponent_Conditional_2_ng_template_0_Template(rf, ctx) {}
function NzTfootSummaryComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTfootSummaryComponent_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 1);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTemplate_r1 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r1);
  }
}
function NzTheadComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function NzTheadComponent_Conditional_2_ng_template_0_Template(rf, ctx) {}
function NzTheadComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTheadComponent_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 1);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTemplate_r1 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r1);
  }
}
const NZ_CONFIG_MODULE_NAME$2 = 'filterTrigger';
let NzFilterTriggerComponent = (() => {
  let _nzBackdrop_decorators;
  let _nzBackdrop_initializers = [];
  let _nzBackdrop_extraInitializers = [];
  return class NzFilterTriggerComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzBackdrop_decorators = [WithConfig()];
      __esDecorate(null, null, _nzBackdrop_decorators, {
        kind: "field",
        name: "nzBackdrop",
        static: false,
        private: false,
        access: {
          has: obj => "nzBackdrop" in obj,
          get: obj => obj.nzBackdrop,
          set: (obj, value) => {
            obj.nzBackdrop = value;
          }
        },
        metadata: _metadata
      }, _nzBackdrop_initializers, _nzBackdrop_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    _nzModuleName = NZ_CONFIG_MODULE_NAME$2;
    nzConfigService = inject(NzConfigService);
    cdr = inject(ChangeDetectorRef);
    destroyRef = inject(DestroyRef);
    nzActive = false;
    nzDropdownMenu;
    nzVisible = false;
    nzBackdrop = __runInitializers(this, _nzBackdrop_initializers, false);
    nzVisibleChange = (__runInitializers(this, _nzBackdrop_extraInitializers), new EventEmitter());
    nzDropdown;
    onVisibleChange(visible) {
      this.nzVisible = visible;
      this.nzVisibleChange.next(visible);
    }
    hide() {
      this.nzVisible = false;
      this.cdr.markForCheck();
    }
    show() {
      this.nzVisible = true;
      this.cdr.markForCheck();
    }
    ngOnInit() {
      fromEventOutsideAngular(this.nzDropdown.nativeElement, 'click').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => event.stopPropagation());
    }
    static ɵfac = function NzFilterTriggerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzFilterTriggerComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzFilterTriggerComponent,
      selectors: [["nz-filter-trigger"]],
      viewQuery: function NzFilterTriggerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NzDropDownDirective, 7, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nzDropdown = _t.first);
        }
      },
      inputs: {
        nzActive: "nzActive",
        nzDropdownMenu: "nzDropdownMenu",
        nzVisible: "nzVisible",
        nzBackdrop: [2, "nzBackdrop", "nzBackdrop", booleanAttribute]
      },
      outputs: {
        nzVisibleChange: "nzVisibleChange"
      },
      exportAs: ["nzFilterTrigger"],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 8,
      consts: [["nz-dropdown", "", "nzTrigger", "click", "nzPlacement", "bottomRight", 1, "ant-table-filter-trigger", 3, "nzVisibleChange", "nzBackdrop", "nzClickHide", "nzDropdownMenu", "nzVisible"]],
      template: function NzFilterTriggerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵlistener("nzVisibleChange", function NzFilterTriggerComponent_Template_span_nzVisibleChange_0_listener($event) {
            return ctx.onVisibleChange($event);
          });
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("active", ctx.nzActive)("ant-table-filter-open", ctx.nzVisible);
          i0.ɵɵproperty("nzBackdrop", ctx.nzBackdrop)("nzClickHide", false)("nzDropdownMenu", ctx.nzDropdownMenu)("nzVisible", ctx.nzVisible);
        }
      },
      dependencies: [NzDropDownModule, i4.NzDropDownDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableFilterComponent = /*#__PURE__*/(() => {
  class NzTableFilterComponent {
    cdr = inject(ChangeDetectorRef);
    i18n = inject(NzI18nService);
    destroyRef = inject(DestroyRef);
    contentTemplate = null;
    customFilter = false;
    extraTemplate = null;
    filterMultiple = true;
    listOfFilter = [];
    filterChange = new EventEmitter();
    locale;
    isChecked = false;
    isVisible = false;
    listOfParsedFilter = [];
    listOfChecked = [];
    check(filter) {
      if (this.filterMultiple) {
        this.listOfParsedFilter = this.listOfParsedFilter.map(item => {
          if (item === filter) {
            return {
              ...item,
              checked: !filter.checked
            };
          } else {
            return item;
          }
        });
        filter.checked = !filter.checked;
      } else {
        this.listOfParsedFilter = this.listOfParsedFilter.map(item => ({
          ...item,
          checked: item === filter
        }));
      }
      this.isChecked = this.getCheckedStatus(this.listOfParsedFilter);
    }
    confirm() {
      this.isVisible = false;
      this.emitFilterData();
    }
    reset() {
      this.isVisible = false;
      this.listOfParsedFilter = this.parseListOfFilter(this.listOfFilter, true);
      this.isChecked = this.getCheckedStatus(this.listOfParsedFilter);
      this.emitFilterData();
    }
    onVisibleChange(value) {
      this.isVisible = value;
      if (!value) {
        this.emitFilterData();
      } else {
        this.listOfChecked = this.listOfParsedFilter.filter(item => item.checked).map(item => item.value);
      }
    }
    emitFilterData() {
      const listOfChecked = this.listOfParsedFilter.filter(item => item.checked).map(item => item.value);
      if (!arraysEqual(this.listOfChecked, listOfChecked)) {
        if (this.filterMultiple) {
          this.filterChange.emit(listOfChecked);
        } else {
          this.filterChange.emit(listOfChecked.length > 0 ? listOfChecked[0] : null);
        }
      }
    }
    parseListOfFilter(listOfFilter, reset) {
      return listOfFilter.map(item => {
        const checked = reset ? false : !!item.byDefault;
        return {
          text: item.text,
          value: item.value,
          checked
        };
      });
    }
    getCheckedStatus(listOfParsedFilter) {
      return listOfParsedFilter.some(item => item.checked);
    }
    ngOnInit() {
      this.i18n.localeChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.locale = this.i18n.getLocaleData('Table');
        this.cdr.markForCheck();
      });
    }
    ngOnChanges(changes) {
      const {
        listOfFilter
      } = changes;
      if (listOfFilter && this.listOfFilter && this.listOfFilter.length) {
        this.listOfParsedFilter = this.parseListOfFilter(this.listOfFilter);
        this.isChecked = this.getCheckedStatus(this.listOfParsedFilter);
      }
    }
    static ɵfac = function NzTableFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableFilterComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableFilterComponent,
      selectors: [["nz-table-filter"]],
      hostAttrs: [1, "ant-table-filter-column"],
      inputs: {
        contentTemplate: "contentTemplate",
        customFilter: "customFilter",
        extraTemplate: "extraTemplate",
        filterMultiple: "filterMultiple",
        listOfFilter: "listOfFilter"
      },
      outputs: {
        filterChange: "filterChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 2,
      consts: [["filterMenu", "nzDropdownMenu"], [1, "ant-table-column-title"], [3, "ngTemplateOutlet"], [3, "nzVisibleChange", "nzVisible", "nzActive", "nzDropdownMenu"], ["nzType", "filter", "nzTheme", "fill"], [1, "ant-table-filter-dropdown"], ["nz-menu", ""], ["nz-menu-item", "", 3, "nzSelected"], [1, "ant-table-filter-dropdown-btns"], ["nz-button", "", "nzType", "link", "nzSize", "small", 3, "click", "disabled"], ["nz-button", "", "nzType", "primary", "nzSize", "small", 3, "click"], ["nz-menu-item", "", 3, "click", "nzSelected"], ["nz-radio", "", 3, "ngModel"], ["nz-checkbox", "", 3, "ngModel"], ["nz-radio", "", 3, "ngModelChange", "ngModel"], ["nz-checkbox", "", 3, "ngModelChange", "ngModel"]],
      template: function NzTableFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 1);
          i0.ɵɵtemplate(1, NzTableFilterComponent_ng_template_1_Template, 0, 0, "ng-template", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵconditionalCreate(2, NzTableFilterComponent_Conditional_2_Template, 13, 6)(3, NzTableFilterComponent_Conditional_3_Template, 1, 1, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.customFilter ? 2 : 3);
        }
      },
      dependencies: [NgTemplateOutlet, NzFilterTriggerComponent, NzIconModule, i1.NzIconDirective, NzDropDownModule, i2.NzMenuDirective, i2.NzMenuItemComponent, i4.NzDropdownMenuComponent, NzRadioComponent, NzCheckboxModule, i4$1.NzCheckboxComponent, FormsModule, i5.NgControlStatus, i5.NgModel, NzButtonModule, i6.NzButtonComponent, i7.ɵNzTransitionPatchDirective, i8.NzWaveDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzRowExpandButtonDirective = /*#__PURE__*/(() => {
  class NzRowExpandButtonDirective {
    expand = false;
    spaceMode = false;
    expandChange = new EventEmitter();
    onHostClick() {
      if (!this.spaceMode) {
        this.expand = !this.expand;
        this.expandChange.next(this.expand);
      }
    }
    static ɵfac = function NzRowExpandButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzRowExpandButtonDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzRowExpandButtonDirective,
      selectors: [["button", "nz-row-expand-button", ""]],
      hostAttrs: [1, "ant-table-row-expand-icon"],
      hostVars: 7,
      hostBindings: function NzRowExpandButtonDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NzRowExpandButtonDirective_click_HostBindingHandler() {
            return ctx.onHostClick();
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("type", "button");
          i0.ɵɵclassProp("ant-table-row-expand-icon-expanded", !ctx.spaceMode && ctx.expand === true)("ant-table-row-expand-icon-collapsed", !ctx.spaceMode && ctx.expand === false)("ant-table-row-expand-icon-spaced", ctx.spaceMode);
        }
      },
      inputs: {
        expand: "expand",
        spaceMode: "spaceMode"
      },
      outputs: {
        expandChange: "expandChange"
      }
    });
  }
  return NzRowExpandButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzRowIndentDirective = /*#__PURE__*/(() => {
  class NzRowIndentDirective {
    indentSize = 0;
    static ɵfac = function NzRowIndentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzRowIndentDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzRowIndentDirective,
      selectors: [["nz-row-indent"]],
      hostAttrs: [1, "ant-table-row-indent"],
      hostVars: 2,
      hostBindings: function NzRowIndentDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("padding-left", ctx.indentSize, "px");
        }
      },
      inputs: {
        indentSize: "indentSize"
      }
    });
  }
  return NzRowIndentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableSelectionComponent = /*#__PURE__*/(() => {
  class NzTableSelectionComponent {
    listOfSelections = [];
    checked = false;
    disabled = false;
    indeterminate = false;
    label = null;
    showCheckbox = false;
    showRowSelection = false;
    checkedChange = new EventEmitter();
    onCheckedChange(checked) {
      this.checked = checked;
      this.checkedChange.emit(checked);
    }
    static ɵfac = function NzTableSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableSelectionComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableSelectionComponent,
      selectors: [["nz-table-selection"]],
      hostAttrs: [1, "ant-table-selection"],
      inputs: {
        listOfSelections: "listOfSelections",
        checked: "checked",
        disabled: "disabled",
        indeterminate: "indeterminate",
        label: "label",
        showCheckbox: "showCheckbox",
        showRowSelection: "showRowSelection"
      },
      outputs: {
        checkedChange: "checkedChange"
      },
      decls: 2,
      vars: 2,
      consts: [["selectionMenu", "nzDropdownMenu"], ["nz-checkbox", "", 3, "ant-table-selection-select-all-custom", "ngModel", "nzDisabled", "nzIndeterminate"], [1, "ant-table-selection-extra"], ["nz-checkbox", "", 3, "ngModelChange", "ngModel", "nzDisabled", "nzIndeterminate"], ["nz-dropdown", "", "nzPlacement", "bottomLeft", 1, "ant-table-selection-down", 3, "nzDropdownMenu"], ["nzType", "down"], ["nz-menu", "", 1, "ant-table-selection-menu"], ["nz-menu-item", ""], ["nz-menu-item", "", 3, "click"]],
      template: function NzTableSelectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, NzTableSelectionComponent_Conditional_0_Template, 1, 6, "label", 1);
          i0.ɵɵconditionalCreate(1, NzTableSelectionComponent_Conditional_1_Template, 8, 1, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.showCheckbox ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showRowSelection ? 1 : -1);
        }
      },
      dependencies: [FormsModule, i5.NgControlStatus, i5.NgModel, NzCheckboxModule, i4$1.NzCheckboxComponent, NzDropDownModule, i2.NzMenuDirective, i2.NzMenuItemComponent, i4.NzDropDownDirective, i4.NzDropdownMenuComponent, NzIconModule, i1.NzIconDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableSortersComponent = /*#__PURE__*/(() => {
  class NzTableSortersComponent {
    sortDirections = ['ascend', 'descend', null];
    sortOrder = null;
    contentTemplate = null;
    isUp = false;
    isDown = false;
    ngOnChanges(changes) {
      const {
        sortDirections
      } = changes;
      if (sortDirections) {
        this.isUp = this.sortDirections.indexOf('ascend') !== -1;
        this.isDown = this.sortDirections.indexOf('descend') !== -1;
      }
    }
    static ɵfac = function NzTableSortersComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableSortersComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableSortersComponent,
      selectors: [["nz-table-sorters"]],
      hostAttrs: [1, "ant-table-column-sorters"],
      inputs: {
        sortDirections: "sortDirections",
        sortOrder: "sortOrder",
        contentTemplate: "contentTemplate"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 6,
      vars: 5,
      consts: [[1, "ant-table-column-title"], [3, "ngTemplateOutlet"], [1, "ant-table-column-sorter"], [1, "ant-table-column-sorter-inner"], ["nzType", "caret-up", 1, "ant-table-column-sorter-up", 3, "active"], ["nzType", "caret-down", 1, "ant-table-column-sorter-down", 3, "active"], ["nzType", "caret-up", 1, "ant-table-column-sorter-up"], ["nzType", "caret-down", 1, "ant-table-column-sorter-down"]],
      template: function NzTableSortersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵtemplate(1, NzTableSortersComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "span", 2)(3, "span", 3);
          i0.ɵɵconditionalCreate(4, NzTableSortersComponent_Conditional_4_Template, 1, 2, "nz-icon", 4);
          i0.ɵɵconditionalCreate(5, NzTableSortersComponent_Conditional_5_Template, 1, 2, "nz-icon", 5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("ant-table-column-sorter-full", ctx.isDown && ctx.isUp);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.isUp ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isDown ? 5 : -1);
        }
      },
      dependencies: [NzIconModule, i1.NzIconDirective, NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableSortersComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCellFixedDirective = /*#__PURE__*/(() => {
  class NzCellFixedDirective {
    renderer = inject(Renderer2);
    el = inject(ElementRef).nativeElement;
    nzRight = false;
    nzLeft = false;
    colspan = null;
    colSpan = null;
    changes$ = new Subject();
    isAutoLeft = false;
    isAutoRight = false;
    isFixedLeft = false;
    isFixedRight = false;
    isFixed = false;
    setAutoLeftWidth(autoLeft) {
      this.renderer.setStyle(this.el, 'left', autoLeft);
    }
    setAutoRightWidth(autoRight) {
      this.renderer.setStyle(this.el, 'right', autoRight);
    }
    setIsFirstRight(isFirstRight) {
      this.setFixClass(isFirstRight, 'ant-table-cell-fix-right-first');
    }
    setIsLastLeft(isLastLeft) {
      this.setFixClass(isLastLeft, 'ant-table-cell-fix-left-last');
    }
    setFixClass(flag, className) {
      // the setFixClass function may call many times, so remove it first.
      this.renderer.removeClass(this.el, className);
      if (flag) {
        this.renderer.addClass(this.el, className);
      }
    }
    ngOnChanges() {
      this.setIsFirstRight(false);
      this.setIsLastLeft(false);
      this.isAutoLeft = this.nzLeft === '' || this.nzLeft === true;
      this.isAutoRight = this.nzRight === '' || this.nzRight === true;
      this.isFixedLeft = this.nzLeft !== false;
      this.isFixedRight = this.nzRight !== false;
      this.isFixed = this.isFixedLeft || this.isFixedRight;
      const validatePx = value => {
        if (typeof value === 'string' && value !== '') {
          return value;
        } else {
          return null;
        }
      };
      this.setAutoLeftWidth(validatePx(this.nzLeft));
      this.setAutoRightWidth(validatePx(this.nzRight));
      this.changes$.next();
    }
    static ɵfac = function NzCellFixedDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzCellFixedDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzCellFixedDirective,
      selectors: [["td", "nzRight", ""], ["th", "nzRight", ""], ["td", "nzLeft", ""], ["th", "nzLeft", ""]],
      hostVars: 6,
      hostBindings: function NzCellFixedDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("position", ctx.isFixed ? "sticky" : null);
          i0.ɵɵclassProp("ant-table-cell-fix-right", ctx.isFixedRight)("ant-table-cell-fix-left", ctx.isFixedLeft);
        }
      },
      inputs: {
        nzRight: "nzRight",
        nzLeft: "nzLeft",
        colspan: "colspan",
        colSpan: "colSpan"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return NzCellFixedDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableStyleService = /*#__PURE__*/(() => {
  class NzTableStyleService {
    theadTemplate$ = new ReplaySubject(1);
    tfootTemplate$ = new ReplaySubject(1);
    tfootFixed$ = new ReplaySubject(1);
    hasFixLeft$ = new ReplaySubject(1);
    hasFixRight$ = new ReplaySubject(1);
    hostWidth$ = new ReplaySubject(1);
    columnCount$ = new ReplaySubject(1);
    showEmpty$ = new ReplaySubject(1);
    noResult$ = new ReplaySubject(1);
    listOfThWidthConfigPx$ = new BehaviorSubject([]);
    tableWidthConfigPx$ = new BehaviorSubject([]);
    manualWidthConfigPx$ = combineLatest([this.tableWidthConfigPx$, this.listOfThWidthConfigPx$]).pipe(map(([widthConfig, listOfWidth]) => widthConfig.length ? widthConfig : listOfWidth));
    listOfAutoWidthPx$ = new ReplaySubject(1);
    listOfListOfThWidthPx$ = merge(/** init with manual width **/
    this.manualWidthConfigPx$, combineLatest([this.listOfAutoWidthPx$, this.manualWidthConfigPx$]).pipe(map(([autoWidth, manualWidth]) => {
      /** use autoWidth until column length match **/
      if (autoWidth.length === manualWidth.length) {
        return autoWidth.map((width, index) => {
          if (width === '0px') {
            return manualWidth[index] || null;
          } else {
            return manualWidth[index] || width;
          }
        });
      } else {
        return manualWidth;
      }
    })));
    listOfMeasureColumn$ = new ReplaySubject(1);
    listOfListOfThWidth$ = this.listOfAutoWidthPx$.pipe(map(list => list.map(width => parseInt(width, 10))));
    enableAutoMeasure$ = new ReplaySubject(1);
    setTheadTemplate(template) {
      this.theadTemplate$.next(template);
    }
    setTfootTemplate(template) {
      this.tfootTemplate$.next(template);
    }
    setTfootFixed(fixed) {
      this.tfootFixed$.next(fixed);
    }
    setHasFixLeft(hasFixLeft) {
      this.hasFixLeft$.next(hasFixLeft);
    }
    setHasFixRight(hasFixRight) {
      this.hasFixRight$.next(hasFixRight);
    }
    setTableWidthConfig(widthConfig) {
      this.tableWidthConfigPx$.next(widthConfig);
    }
    setListOfTh(listOfTh) {
      let columnCount = 0;
      listOfTh.forEach(th => {
        columnCount += th.colspan && +th.colspan || th.colSpan && +th.colSpan || 1;
      });
      const listOfThPx = listOfTh.map(item => item.nzWidth);
      this.columnCount$.next(columnCount);
      this.listOfThWidthConfigPx$.next(listOfThPx);
    }
    setListOfMeasureColumn(listOfTh) {
      const listOfKeys = [];
      listOfTh.forEach(th => {
        const length = th.colspan && +th.colspan || th.colSpan && +th.colSpan || 1;
        for (let i = 0; i < length; i++) {
          listOfKeys.push(`measure_key_${i}`);
        }
      });
      this.listOfMeasureColumn$.next(listOfKeys);
    }
    setListOfAutoWidth(listOfAutoWidth) {
      this.listOfAutoWidthPx$.next(listOfAutoWidth.map(width => `${width}px`));
    }
    setShowEmpty(showEmpty) {
      this.showEmpty$.next(showEmpty);
    }
    setNoResult(noResult) {
      this.noResult$.next(noResult);
    }
    setScroll(scrollX, scrollY) {
      const enableAutoMeasure = !!(scrollX || scrollY);
      if (!enableAutoMeasure) {
        this.setListOfAutoWidth([]);
      }
      this.enableAutoMeasure$.next(enableAutoMeasure);
    }
    static ɵfac = function NzTableStyleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableStyleService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NzTableStyleService,
      factory: NzTableStyleService.ɵfac
    });
  }
  return NzTableStyleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableCellDirective = /*#__PURE__*/(() => {
  class NzTableCellDirective {
    isInsideTable = !!inject(NzTableStyleService, {
      optional: true
    });
    static ɵfac = function NzTableCellDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableCellDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzTableCellDirective,
      selectors: [["th", 9, "nz-disable-th"], ["td", 9, "nz-disable-td"]],
      hostVars: 2,
      hostBindings: function NzTableCellDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-cell", ctx.isInsideTable);
        }
      }
    });
  }
  return NzTableCellDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableDataService = /*#__PURE__*/(() => {
  class NzTableDataService {
    destroyRef = inject(DestroyRef);
    pageIndex$ = new BehaviorSubject(1);
    frontPagination$ = new BehaviorSubject(true);
    pageSize$ = new BehaviorSubject(10);
    listOfData$ = new BehaviorSubject([]);
    listOfCustomColumn$ = new BehaviorSubject([]);
    pageIndexDistinct$ = this.pageIndex$.pipe(distinctUntilChanged());
    pageSizeDistinct$ = this.pageSize$.pipe(distinctUntilChanged());
    listOfCalcOperator$ = new BehaviorSubject([]);
    queryParams$ = combineLatest([this.pageIndexDistinct$, this.pageSizeDistinct$, this.listOfCalcOperator$]).pipe(debounceTime(0), skip(1), map(([pageIndex, pageSize, listOfCalc]) => ({
      pageIndex,
      pageSize,
      sort: listOfCalc.filter(item => item.sortFn).map(item => ({
        key: item.key,
        value: item.sortOrder
      })),
      filter: listOfCalc.filter(item => item.filterFn).map(item => ({
        key: item.key,
        value: item.filterValue
      }))
    })));
    listOfDataAfterCalc$ = combineLatest([this.listOfData$, this.listOfCalcOperator$]).pipe(map(([listOfData, listOfCalcOperator]) => {
      let listOfDataAfterCalc = [...listOfData];
      const listOfFilterOperator = listOfCalcOperator.filter(item => {
        const {
          filterValue,
          filterFn
        } = item;
        const isReset = filterValue === null || filterValue === undefined || Array.isArray(filterValue) && filterValue.length === 0;
        return !isReset && typeof filterFn === 'function';
      });
      for (const item of listOfFilterOperator) {
        const {
          filterFn,
          filterValue
        } = item;
        listOfDataAfterCalc = listOfDataAfterCalc.filter(data => filterFn(filterValue, data));
      }
      const listOfSortOperator = listOfCalcOperator.filter(item => item.sortOrder !== null && typeof item.sortFn === 'function').sort((a, b) => +b.sortPriority - +a.sortPriority);
      if (listOfCalcOperator.length) {
        listOfDataAfterCalc.sort((record1, record2) => {
          for (const item of listOfSortOperator) {
            const {
              sortFn,
              sortOrder
            } = item;
            if (sortFn && sortOrder) {
              const compareResult = sortFn(record1, record2, sortOrder);
              if (compareResult !== 0) {
                return sortOrder === 'ascend' ? compareResult : -compareResult;
              }
            }
          }
          return 0;
        });
      }
      return listOfDataAfterCalc;
    }));
    listOfFrontEndCurrentPageData$ = combineLatest([this.pageIndexDistinct$, this.pageSizeDistinct$, this.listOfDataAfterCalc$]).pipe(takeUntilDestroyed(this.destroyRef), filter(value => {
      const [pageIndex, pageSize, listOfData] = value;
      const maxPageIndex = Math.ceil(listOfData.length / pageSize) || 1;
      return pageIndex <= maxPageIndex;
    }), map(([pageIndex, pageSize, listOfData]) => listOfData.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)));
    listOfCurrentPageData$ = this.frontPagination$.pipe(switchMap(pagination => pagination ? this.listOfFrontEndCurrentPageData$ : this.listOfDataAfterCalc$));
    total$ = this.frontPagination$.pipe(switchMap(pagination => pagination ? this.listOfDataAfterCalc$ : this.listOfData$), map(list => list.length), distinctUntilChanged());
    updatePageSize(size) {
      this.pageSize$.next(size);
    }
    updateFrontPagination(pagination) {
      this.frontPagination$.next(pagination);
    }
    updatePageIndex(index) {
      this.pageIndex$.next(index);
    }
    updateListOfData(list) {
      this.listOfData$.next(list);
    }
    updateListOfCustomColumn(list) {
      this.listOfCustomColumn$.next(list);
    }
    static ɵfac = function NzTableDataService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableDataService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NzTableDataService,
      factory: NzTableDataService.ɵfac
    });
  }
  return NzTableDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCustomColumnDirective = /*#__PURE__*/(() => {
  class NzCustomColumnDirective {
    el = inject(ElementRef).nativeElement;
    renderer = inject(Renderer2);
    nzTableDataService = inject(NzTableDataService);
    destroyRef = inject(DestroyRef);
    nzCellControl = null;
    ngOnInit() {
      this.nzTableDataService.listOfCustomColumn$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(item => {
        item.forEach((v, i) => {
          if (v.value === this.nzCellControl) {
            this.renderer.setStyle(this.el, 'display', v.default ? 'block' : 'none');
            this.renderer.setStyle(this.el, 'order', i);
            this.renderer.setStyle(this.el, 'flex', v.fixWidth ? `1 0 ${v.width}px` : `1 1 ${v.width}px`);
          }
        });
      });
    }
    static ɵfac = function NzCustomColumnDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzCustomColumnDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzCustomColumnDirective,
      selectors: [["td", "nzCellControl", ""], ["th", "nzCellControl", ""]],
      inputs: {
        nzCellControl: "nzCellControl"
      }
    });
  }
  return NzCustomColumnDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/* eslint-disable @angular-eslint/component-selector */
let NzTdAddOnComponent = /*#__PURE__*/(() => {
  class NzTdAddOnComponent {
    nzChecked = false;
    nzDisabled = false;
    nzIndeterminate = false;
    nzLabel = null;
    nzIndentSize = 0;
    nzShowExpand = false;
    nzShowCheckbox = false;
    nzExpand = false;
    nzExpandIcon = null;
    nzCheckedChange = new EventEmitter();
    nzExpandChange = new EventEmitter();
    isNzShowExpandChanged = false;
    isNzShowCheckboxChanged = false;
    onCheckedChange(checked) {
      this.nzChecked = checked;
      this.nzCheckedChange.emit(checked);
    }
    onExpandChange(expand) {
      this.nzExpand = expand;
      this.nzExpandChange.emit(expand);
    }
    ngOnChanges(changes) {
      const isFirstChange = value => value && value.firstChange && value.currentValue !== undefined;
      const {
        nzExpand,
        nzChecked,
        nzShowExpand,
        nzShowCheckbox
      } = changes;
      if (nzShowExpand) {
        this.isNzShowExpandChanged = true;
      }
      if (nzShowCheckbox) {
        this.isNzShowCheckboxChanged = true;
      }
      if (isFirstChange(nzExpand) && !this.isNzShowExpandChanged) {
        this.nzShowExpand = true;
      }
      if (isFirstChange(nzChecked) && !this.isNzShowCheckboxChanged) {
        this.nzShowCheckbox = true;
      }
    }
    static ɵfac = function NzTdAddOnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTdAddOnComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTdAddOnComponent,
      selectors: [["td", "nzChecked", ""], ["td", "nzDisabled", ""], ["td", "nzIndeterminate", ""], ["td", "nzIndentSize", ""], ["td", "nzExpand", ""], ["td", "nzShowExpand", ""], ["td", "nzShowCheckbox", ""]],
      hostVars: 4,
      hostBindings: function NzTdAddOnComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-cell-with-append", ctx.nzShowExpand || ctx.nzIndentSize > 0)("ant-table-selection-column", ctx.nzShowCheckbox);
        }
      },
      inputs: {
        nzChecked: "nzChecked",
        nzDisabled: "nzDisabled",
        nzIndeterminate: "nzIndeterminate",
        nzLabel: "nzLabel",
        nzIndentSize: "nzIndentSize",
        nzShowExpand: [2, "nzShowExpand", "nzShowExpand", booleanAttribute],
        nzShowCheckbox: [2, "nzShowCheckbox", "nzShowCheckbox", booleanAttribute],
        nzExpand: [2, "nzExpand", "nzExpand", booleanAttribute],
        nzExpandIcon: "nzExpandIcon"
      },
      outputs: {
        nzCheckedChange: "nzCheckedChange",
        nzExpandChange: "nzExpandChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c1,
      ngContentSelectors: _c0,
      decls: 3,
      vars: 2,
      consts: [["nz-checkbox", "", 3, "nzDisabled", "ngModel", "nzIndeterminate"], [3, "indentSize"], [3, "ngTemplateOutlet"], ["nz-row-expand-button", "", 3, "expand", "spaceMode"], ["nz-row-expand-button", "", 3, "expandChange", "expand", "spaceMode"], ["nz-checkbox", "", 3, "ngModelChange", "nzDisabled", "ngModel", "nzIndeterminate"]],
      template: function NzTdAddOnComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, NzTdAddOnComponent_Conditional_0_Template, 3, 2);
          i0.ɵɵconditionalCreate(1, NzTdAddOnComponent_Conditional_1_Template, 1, 4, "label", 0);
          i0.ɵɵprojection(2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.nzShowExpand || ctx.nzIndentSize > 0 ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzShowCheckbox ? 1 : -1);
        }
      },
      dependencies: [NzRowIndentDirective, NzRowExpandButtonDirective, NgTemplateOutlet, NzCheckboxModule, i4$1.NzCheckboxComponent, FormsModule, i5.NgControlStatus, i5.NgModel],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTdAddOnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME$1 = 'table';
let NzThAddOnComponent = (() => {
  let _nzSortDirections_decorators;
  let _nzSortDirections_initializers = [];
  let _nzSortDirections_extraInitializers = [];
  return class NzThAddOnComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzSortDirections_decorators = [WithConfig()];
      __esDecorate(null, null, _nzSortDirections_decorators, {
        kind: "field",
        name: "nzSortDirections",
        static: false,
        private: false,
        access: {
          has: obj => "nzSortDirections" in obj,
          get: obj => obj.nzSortDirections,
          set: (obj, value) => {
            obj.nzSortDirections = value;
          }
        },
        metadata: _metadata
      }, _nzSortDirections_initializers, _nzSortDirections_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    _nzModuleName = NZ_CONFIG_MODULE_NAME$1;
    nzConfigService = inject(NzConfigService);
    el = inject(ElementRef).nativeElement;
    destroyRef = inject(DestroyRef);
    cdr = inject(ChangeDetectorRef);
    ngZone = inject(NgZone);
    manualClickOrder$ = new Subject();
    calcOperatorChange$ = new Subject();
    nzFilterValue = null;
    sortOrder = null;
    sortDirections = ['ascend', 'descend', null];
    sortOrderChange$ = new Subject();
    isNzShowSortChanged = false;
    isNzShowFilterChanged = false;
    nzColumnKey;
    nzFilterMultiple = true;
    nzSortOrder = null;
    nzSortPriority = false;
    nzSortDirections = __runInitializers(this, _nzSortDirections_initializers, ['ascend', 'descend', null]);
    nzFilters = (__runInitializers(this, _nzSortDirections_extraInitializers), []);
    nzSortFn = null;
    nzFilterFn = null;
    nzShowSort = false;
    nzShowFilter = false;
    nzCustomFilter = false;
    nzCheckedChange = new EventEmitter();
    nzSortOrderChange = new EventEmitter();
    nzFilterChange = new EventEmitter();
    getNextSortDirection(sortDirections, current) {
      const index = sortDirections.indexOf(current);
      if (index === sortDirections.length - 1) {
        return sortDirections[0];
      } else {
        return sortDirections[index + 1];
      }
    }
    setSortOrder(order) {
      this.sortOrderChange$.next(order);
    }
    clearSortOrder() {
      if (this.sortOrder !== null) {
        this.setSortOrder(null);
      }
    }
    onFilterValueChange(value) {
      this.nzFilterChange.emit(value);
      this.nzFilterValue = value;
      this.updateCalcOperator();
    }
    updateCalcOperator() {
      this.calcOperatorChange$.next();
    }
    ngOnInit() {
      fromEventOutsideAngular(this.el, 'click').pipe(filter(() => this.nzShowSort), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        const nextOrder = this.getNextSortDirection(this.sortDirections, this.sortOrder);
        this.ngZone.run(() => {
          this.setSortOrder(nextOrder);
          this.manualClickOrder$.next(this);
        });
      });
      this.sortOrderChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(order => {
        if (this.sortOrder !== order) {
          this.sortOrder = order;
          this.nzSortOrderChange.emit(order);
        }
        this.updateCalcOperator();
        this.cdr.markForCheck();
      });
    }
    ngOnChanges(changes) {
      const {
        nzSortDirections,
        nzFilters,
        nzSortOrder,
        nzSortFn,
        nzFilterFn,
        nzSortPriority,
        nzFilterMultiple,
        nzShowSort,
        nzShowFilter
      } = changes;
      if (nzSortDirections) {
        if (this.nzSortDirections && this.nzSortDirections.length) {
          this.sortDirections = this.nzSortDirections;
        }
      }
      if (nzSortOrder) {
        this.sortOrder = this.nzSortOrder;
        this.setSortOrder(this.nzSortOrder);
      }
      if (nzShowSort) {
        this.isNzShowSortChanged = true;
      }
      if (nzShowFilter) {
        this.isNzShowFilterChanged = true;
      }
      const isFirstChange = value => value && value.firstChange && value.currentValue !== undefined;
      if ((isFirstChange(nzSortOrder) || isFirstChange(nzSortFn)) && !this.isNzShowSortChanged) {
        this.nzShowSort = true;
      }
      if (isFirstChange(nzFilters) && !this.isNzShowFilterChanged) {
        this.nzShowFilter = true;
      }
      if ((nzFilters || nzFilterMultiple) && this.nzShowFilter) {
        const listOfValue = this.nzFilters.filter(item => item.byDefault).map(item => item.value);
        this.nzFilterValue = this.nzFilterMultiple ? listOfValue : listOfValue[0] || null;
      }
      if (nzSortFn || nzFilterFn || nzSortPriority || nzFilters) {
        this.updateCalcOperator();
      }
    }
    static ɵfac = function NzThAddOnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzThAddOnComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzThAddOnComponent,
      selectors: [["th", "nzColumnKey", ""], ["th", "nzSortFn", ""], ["th", "nzSortOrder", ""], ["th", "nzFilters", ""], ["th", "nzShowSort", ""], ["th", "nzShowFilter", ""], ["th", "nzCustomFilter", ""]],
      hostVars: 4,
      hostBindings: function NzThAddOnComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-column-has-sorters", ctx.nzShowSort)("ant-table-column-sort", ctx.sortOrder === "descend" || ctx.sortOrder === "ascend");
        }
      },
      inputs: {
        nzColumnKey: "nzColumnKey",
        nzFilterMultiple: "nzFilterMultiple",
        nzSortOrder: "nzSortOrder",
        nzSortPriority: "nzSortPriority",
        nzSortDirections: "nzSortDirections",
        nzFilters: "nzFilters",
        nzSortFn: "nzSortFn",
        nzFilterFn: "nzFilterFn",
        nzShowSort: [2, "nzShowSort", "nzShowSort", booleanAttribute],
        nzShowFilter: [2, "nzShowFilter", "nzShowFilter", booleanAttribute],
        nzCustomFilter: [2, "nzCustomFilter", "nzCustomFilter", booleanAttribute]
      },
      outputs: {
        nzCheckedChange: "nzCheckedChange",
        nzSortOrderChange: "nzSortOrderChange",
        nzFilterChange: "nzFilterChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c2,
      ngContentSelectors: _c4,
      decls: 10,
      vars: 1,
      consts: [["notFilterTemplate", ""], ["extraTemplate", ""], ["sortTemplate", ""], ["contentTemplate", ""], [3, "contentTemplate", "extraTemplate", "customFilter", "filterMultiple", "listOfFilter"], [3, "ngTemplateOutlet"], [3, "filterChange", "contentTemplate", "extraTemplate", "customFilter", "filterMultiple", "listOfFilter"], [3, "sortOrder", "sortDirections", "contentTemplate"]],
      template: function NzThAddOnComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵconditionalCreate(0, NzThAddOnComponent_Conditional_0_Template, 1, 5, "nz-table-filter", 4)(1, NzThAddOnComponent_Conditional_1_Template, 1, 1, "ng-container", 5);
          i0.ɵɵtemplate(2, NzThAddOnComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, NzThAddOnComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, NzThAddOnComponent_ng_template_6_Template, 1, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, NzThAddOnComponent_ng_template_8_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.nzShowFilter || ctx.nzCustomFilter ? 0 : 1);
        }
      },
      dependencies: [NzTableFilterComponent, NgTemplateOutlet, NzTableSortersComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzThMeasureDirective = /*#__PURE__*/(() => {
  class NzThMeasureDirective {
    renderer = inject(Renderer2);
    el = inject(ElementRef).nativeElement;
    changes$ = new Subject();
    nzWidth = null;
    colspan = null;
    colSpan = null;
    rowspan = null;
    rowSpan = null;
    ngOnChanges(changes) {
      const {
        nzWidth,
        colspan,
        rowspan,
        colSpan,
        rowSpan
      } = changes;
      if (colspan || colSpan) {
        const col = this.colspan || this.colSpan;
        if (!isNil(col)) {
          this.renderer.setAttribute(this.el, 'colspan', `${col}`);
        } else {
          this.renderer.removeAttribute(this.el, 'colspan');
        }
      }
      if (rowspan || rowSpan) {
        const row = this.rowspan || this.rowSpan;
        if (!isNil(row)) {
          this.renderer.setAttribute(this.el, 'rowspan', `${row}`);
        } else {
          this.renderer.removeAttribute(this.el, 'rowspan');
        }
      }
      if (nzWidth || colspan) {
        this.changes$.next();
      }
    }
    static ɵfac = function NzThMeasureDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzThMeasureDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzThMeasureDirective,
      selectors: [["th"]],
      inputs: {
        nzWidth: "nzWidth",
        colspan: "colspan",
        colSpan: "colSpan",
        rowspan: "rowspan",
        rowSpan: "rowSpan"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return NzThMeasureDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/* eslint-disable @angular-eslint/component-selector */
let NzThSelectionComponent = /*#__PURE__*/(() => {
  class NzThSelectionComponent {
    nzSelections = [];
    nzChecked = false;
    nzDisabled = false;
    nzIndeterminate = false;
    nzLabel = null;
    nzShowCheckbox = false;
    nzShowRowSelection = false;
    nzCheckedChange = new EventEmitter();
    isNzShowExpandChanged = false;
    isNzShowCheckboxChanged = false;
    onCheckedChange(checked) {
      this.nzChecked = checked;
      this.nzCheckedChange.emit(checked);
    }
    ngOnChanges(changes) {
      const isFirstChange = value => value && value.firstChange && value.currentValue !== undefined;
      const {
        nzChecked,
        nzSelections,
        nzShowExpand,
        nzShowCheckbox
      } = changes;
      if (nzShowExpand) {
        this.isNzShowExpandChanged = true;
      }
      if (nzShowCheckbox) {
        this.isNzShowCheckboxChanged = true;
      }
      if (isFirstChange(nzSelections) && !this.isNzShowExpandChanged) {
        this.nzShowRowSelection = true;
      }
      if (isFirstChange(nzChecked) && !this.isNzShowCheckboxChanged) {
        this.nzShowCheckbox = true;
      }
    }
    static ɵfac = function NzThSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzThSelectionComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzThSelectionComponent,
      selectors: [["th", "nzSelections", ""], ["th", "nzChecked", ""], ["th", "nzShowCheckbox", ""], ["th", "nzShowRowSelection", ""]],
      hostAttrs: [1, "ant-table-selection-column"],
      inputs: {
        nzSelections: "nzSelections",
        nzChecked: [2, "nzChecked", "nzChecked", booleanAttribute],
        nzDisabled: [2, "nzDisabled", "nzDisabled", booleanAttribute],
        nzIndeterminate: "nzIndeterminate",
        nzLabel: "nzLabel",
        nzShowCheckbox: [2, "nzShowCheckbox", "nzShowCheckbox", booleanAttribute],
        nzShowRowSelection: [2, "nzShowRowSelection", "nzShowRowSelection", booleanAttribute]
      },
      outputs: {
        nzCheckedChange: "nzCheckedChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c5,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 7,
      consts: [[3, "checkedChange", "checked", "disabled", "indeterminate", "label", "listOfSelections", "showCheckbox", "showRowSelection"]],
      template: function NzThSelectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "nz-table-selection", 0);
          i0.ɵɵlistener("checkedChange", function NzThSelectionComponent_Template_nz_table_selection_checkedChange_0_listener($event) {
            return ctx.onCheckedChange($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("checked", ctx.nzChecked)("disabled", ctx.nzDisabled)("indeterminate", ctx.nzIndeterminate)("label", ctx.nzLabel)("listOfSelections", ctx.nzSelections)("showCheckbox", ctx.nzShowCheckbox)("showRowSelection", ctx.nzShowRowSelection);
        }
      },
      dependencies: [NzTableSelectionComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzThSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCellAlignDirective = /*#__PURE__*/(() => {
  class NzCellAlignDirective {
    nzAlign = null;
    static ɵfac = function NzCellAlignDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzCellAlignDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzCellAlignDirective,
      selectors: [["th", "nzAlign", ""], ["td", "nzAlign", ""]],
      hostVars: 2,
      hostBindings: function NzCellAlignDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("text-align", ctx.nzAlign);
        }
      },
      inputs: {
        nzAlign: "nzAlign"
      }
    });
  }
  return NzCellAlignDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCellEllipsisDirective = /*#__PURE__*/(() => {
  class NzCellEllipsisDirective {
    nzEllipsis = true;
    static ɵfac = function NzCellEllipsisDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzCellEllipsisDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzCellEllipsisDirective,
      selectors: [["th", "nzEllipsis", ""], ["td", "nzEllipsis", ""]],
      hostVars: 2,
      hostBindings: function NzCellEllipsisDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-cell-ellipsis", ctx.nzEllipsis);
        }
      },
      inputs: {
        nzEllipsis: [2, "nzEllipsis", "nzEllipsis", booleanAttribute]
      }
    });
  }
  return NzCellEllipsisDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCellBreakWordDirective = /*#__PURE__*/(() => {
  class NzCellBreakWordDirective {
    nzBreakWord = true;
    static ɵfac = function NzCellBreakWordDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzCellBreakWordDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzCellBreakWordDirective,
      selectors: [["th", "nzBreakWord", ""], ["td", "nzBreakWord", ""]],
      hostVars: 2,
      hostBindings: function NzCellBreakWordDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("word-break", ctx.nzBreakWord ? "break-all" : "");
        }
      },
      inputs: {
        nzBreakWord: [2, "nzBreakWord", "nzBreakWord", booleanAttribute]
      }
    });
  }
  return NzCellBreakWordDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableContentComponent = /*#__PURE__*/(() => {
  class NzTableContentComponent {
    tableLayout = 'auto';
    theadTemplate = null;
    contentTemplate = null;
    tfootTemplate = null;
    listOfColWidth = [];
    scrollX = null;
    static ɵfac = function NzTableContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableContentComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableContentComponent,
      selectors: [["table", "nz-table-content", ""]],
      hostVars: 8,
      hostBindings: function NzTableContentComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("table-layout", ctx.tableLayout)("width", ctx.scrollX)("min-width", ctx.scrollX ? "100%" : null);
          i0.ɵɵclassProp("ant-table-fixed", ctx.scrollX);
        }
      },
      inputs: {
        tableLayout: "tableLayout",
        theadTemplate: "theadTemplate",
        contentTemplate: "contentTemplate",
        tfootTemplate: "tfootTemplate",
        listOfColWidth: "listOfColWidth",
        scrollX: "scrollX"
      },
      attrs: _c6,
      ngContentSelectors: _c0,
      decls: 5,
      vars: 4,
      consts: [[1, "ant-table-thead"], [3, "ngTemplateOutlet"], [1, "ant-table-summary"], [3, "width", "minWidth"]],
      template: function NzTableContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, NzTableContentComponent_Conditional_0_Template, 3, 0, "colgroup");
          i0.ɵɵconditionalCreate(1, NzTableContentComponent_Conditional_1_Template, 2, 1, "thead", 0);
          i0.ɵɵtemplate(2, NzTableContentComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
          i0.ɵɵprojection(3);
          i0.ɵɵconditionalCreate(4, NzTableContentComponent_Conditional_4_Template, 2, 1, "tfoot", 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.listOfColWidth.length > 0 ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.theadTemplate ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.tfootTemplate ? 4 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableFixedRowComponent = /*#__PURE__*/(() => {
  class NzTableFixedRowComponent {
    nzTableStyleService = inject(NzTableStyleService);
    renderer = inject(Renderer2);
    destroyRef = inject(DestroyRef);
    tdElement;
    hostWidth$ = new BehaviorSubject(null);
    enableAutoMeasure$ = new BehaviorSubject(false);
    ngOnInit() {
      if (this.nzTableStyleService) {
        const {
          enableAutoMeasure$,
          hostWidth$
        } = this.nzTableStyleService;
        enableAutoMeasure$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.enableAutoMeasure$);
        hostWidth$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.hostWidth$);
      }
    }
    ngAfterViewInit() {
      this.nzTableStyleService.columnCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(count => {
        this.renderer.setAttribute(this.tdElement.nativeElement, 'colspan', `${count}`);
      });
    }
    static ɵfac = function NzTableFixedRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableFixedRowComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableFixedRowComponent,
      selectors: [["tr", "nz-table-fixed-row", ""], ["tr", "nzExpand", ""]],
      viewQuery: function NzTableFixedRowComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tdElement = _t.first);
        }
      },
      attrs: _c8,
      ngContentSelectors: _c0,
      decls: 7,
      vars: 3,
      consts: [["tdElement", ""], ["contentTemplate", ""], [1, "nz-disable-td", "ant-table-cell"], [1, "ant-table-expanded-row-fixed", 2, "position", "sticky", "left", "0", "overflow", "hidden", 3, "width"], [3, "ngTemplateOutlet"], [1, "ant-table-expanded-row-fixed", 2, "position", "sticky", "left", "0", "overflow", "hidden"]],
      template: function NzTableFixedRowComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "td", 2, 0);
          i0.ɵɵconditionalCreate(2, NzTableFixedRowComponent_Conditional_2_Template, 3, 5, "div", 3);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵconditionalBranchCreate(4, NzTableFixedRowComponent_Conditional_4_Template, 1, 1, null, 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, NzTableFixedRowComponent_ng_template_5_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 1, ctx.enableAutoMeasure$) ? 2 : 4);
        }
      },
      dependencies: [AsyncPipe, NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableFixedRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableInnerDefaultComponent = /*#__PURE__*/(() => {
  class NzTableInnerDefaultComponent {
    tableLayout = 'auto';
    listOfColWidth = [];
    theadTemplate = null;
    contentTemplate = null;
    tfootTemplate = null;
    static ɵfac = function NzTableInnerDefaultComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableInnerDefaultComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableInnerDefaultComponent,
      selectors: [["nz-table-inner-default"]],
      hostAttrs: [1, "ant-table-container"],
      inputs: {
        tableLayout: "tableLayout",
        listOfColWidth: "listOfColWidth",
        theadTemplate: "theadTemplate",
        contentTemplate: "contentTemplate",
        tfootTemplate: "tfootTemplate"
      },
      decls: 2,
      vars: 5,
      consts: [[1, "ant-table-content"], ["nz-table-content", "", 3, "contentTemplate", "tableLayout", "listOfColWidth", "theadTemplate", "tfootTemplate"]],
      template: function NzTableInnerDefaultComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "table", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("contentTemplate", ctx.contentTemplate)("tableLayout", ctx.tableLayout)("listOfColWidth", ctx.listOfColWidth)("theadTemplate", ctx.theadTemplate)("tfootTemplate", ctx.tfootTemplate);
        }
      },
      dependencies: [NzTableContentComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableInnerDefaultComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTrMeasureComponent = /*#__PURE__*/(() => {
  class NzTrMeasureComponent {
    nzResizeObserver = inject(NzResizeObserver);
    ngZone = inject(NgZone);
    destroyRef = inject(DestroyRef);
    listOfMeasureColumn = [];
    listOfAutoWidth = new EventEmitter();
    listOfTdElement;
    ngAfterViewInit() {
      this.listOfTdElement.changes.pipe(startWith(this.listOfTdElement)).pipe(switchMap(list => combineLatest(list.toArray().map(item => this.nzResizeObserver.observe(item).pipe(map(([entry]) => {
        const {
          width
        } = entry.target.getBoundingClientRect();
        return Math.floor(width);
      }))))), debounceTime(16), takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        // Caretaker note: we don't have to re-enter the Angular zone each time the stream emits.
        // The below check is necessary to be sure that zone is not nooped through `BootstrapOptions`
        // (`bootstrapModule(AppModule, { ngZone: 'noop' }))`. The `ngZone instanceof NgZone` may return
        // `false` if zone is nooped, since `ngZone` will be an instance of the `NoopNgZone`.
        // The `ResizeObserver` might be also patched through `zone.js/dist/zone-patch-resize-observer`,
        // thus calling `ngZone.run` again will cause another change detection.
        if (this.ngZone instanceof NgZone && NgZone.isInAngularZone()) {
          this.listOfAutoWidth.next(data);
        } else {
          this.ngZone.run(() => this.listOfAutoWidth.next(data));
        }
      });
    }
    static ɵfac = function NzTrMeasureComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTrMeasureComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTrMeasureComponent,
      selectors: [["tr", "nz-table-measure-row", ""]],
      viewQuery: function NzTrMeasureComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfTdElement = _t);
        }
      },
      hostAttrs: [1, "ant-table-measure-now"],
      inputs: {
        listOfMeasureColumn: "listOfMeasureColumn"
      },
      outputs: {
        listOfAutoWidth: "listOfAutoWidth"
      },
      attrs: _c9,
      decls: 2,
      vars: 0,
      consts: [["tdElement", ""], [1, "nz-disable-td", 2, "padding", "0", "border", "0", "height", "0"]],
      template: function NzTrMeasureComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, NzTrMeasureComponent_For_1_Template, 2, 0, "td", 1, i0.ɵɵrepeaterTrackByIndex);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.listOfMeasureColumn);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTrMeasureComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/* eslint-disable @angular-eslint/component-selector */
let NzTbodyComponent = /*#__PURE__*/(() => {
  class NzTbodyComponent {
    showEmpty$ = new BehaviorSubject(false);
    noResult$ = new BehaviorSubject(undefined);
    listOfMeasureColumn$ = new BehaviorSubject([]);
    nzTableStyleService = inject(NzTableStyleService, {
      optional: true
    });
    isInsideTable = !!this.nzTableStyleService;
    constructor() {
      if (this.nzTableStyleService) {
        const {
          showEmpty$,
          noResult$,
          listOfMeasureColumn$
        } = this.nzTableStyleService;
        noResult$.pipe(takeUntilDestroyed()).subscribe(this.noResult$);
        listOfMeasureColumn$.pipe(takeUntilDestroyed()).subscribe(this.listOfMeasureColumn$);
        showEmpty$.pipe(takeUntilDestroyed()).subscribe(this.showEmpty$);
      }
    }
    onListOfAutoWidthChange(listOfAutoWidth) {
      this.nzTableStyleService?.setListOfAutoWidth(listOfAutoWidth);
    }
    static ɵfac = function NzTbodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTbodyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTbodyComponent,
      selectors: [["tbody"]],
      hostVars: 2,
      hostBindings: function NzTbodyComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-tbody", ctx.isInsideTable);
        }
      },
      ngContentSelectors: _c0,
      decls: 5,
      vars: 6,
      consts: [["nz-table-fixed-row", "", 1, "ant-table-placeholder"], ["nz-table-measure-row", "", 3, "listOfMeasureColumn"], ["nz-table-measure-row", "", 3, "listOfAutoWidth", "listOfMeasureColumn"], ["nzComponentName", "table", 3, "specificContent"]],
      template: function NzTbodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, NzTbodyComponent_Conditional_0_Template, 1, 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵprojection(2);
          i0.ɵɵconditionalCreate(3, NzTbodyComponent_Conditional_3_Template, 3, 3, "tr", 0);
          i0.ɵɵpipe(4, "async");
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 2, ctx.listOfMeasureColumn$)) ? 0 : -1, tmp_0_0);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 4, ctx.showEmpty$) ? 3 : -1);
        }
      },
      dependencies: [AsyncPipe, NzTrMeasureComponent, NzTableFixedRowComponent, NzEmptyModule, i1$1.NzEmbedEmptyComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTbodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableInnerScrollComponent = /*#__PURE__*/(() => {
  class NzTableInnerScrollComponent {
    renderer = inject(Renderer2);
    ngZone = inject(NgZone);
    platform = inject(Platform);
    resizeService = inject(NzResizeService);
    destroyRef = inject(DestroyRef);
    data = [];
    scrollX = null;
    scrollY = null;
    contentTemplate = null;
    widthConfig = [];
    listOfColWidth = [];
    theadTemplate = null;
    tfootTemplate = null;
    tfootFixed = null;
    virtualTemplate = null;
    virtualItemSize = 0;
    virtualMaxBufferPx = 200;
    virtualMinBufferPx = 100;
    tableMainElement;
    virtualForTrackBy = index => index;
    tableHeaderElement;
    tableBodyElement;
    tableFootElement;
    cdkVirtualScrollViewport;
    headerStyleMap = {};
    bodyStyleMap = {};
    verticalScrollBarWidth = 0;
    noDataVirtualHeight = '182px';
    data$ = new Subject();
    scroll$ = new Subject();
    setScrollPositionClassName(clear = false) {
      const {
        scrollWidth,
        scrollLeft,
        clientWidth
      } = this.tableBodyElement.nativeElement;
      const leftClassName = 'ant-table-ping-left';
      const rightClassName = 'ant-table-ping-right';
      if (scrollWidth === clientWidth && scrollWidth !== 0 || clear) {
        this.renderer.removeClass(this.tableMainElement, leftClassName);
        this.renderer.removeClass(this.tableMainElement, rightClassName);
      } else if (scrollLeft === 0) {
        this.renderer.removeClass(this.tableMainElement, leftClassName);
        this.renderer.addClass(this.tableMainElement, rightClassName);
      } else if (scrollWidth === scrollLeft + clientWidth) {
        this.renderer.removeClass(this.tableMainElement, rightClassName);
        this.renderer.addClass(this.tableMainElement, leftClassName);
      } else {
        this.renderer.addClass(this.tableMainElement, leftClassName);
        this.renderer.addClass(this.tableMainElement, rightClassName);
      }
    }
    constructor() {
      this.destroyRef.onDestroy(() => {
        this.setScrollPositionClassName(true);
      });
    }
    ngOnChanges(changes) {
      const {
        scrollX,
        scrollY,
        data
      } = changes;
      if (scrollX || scrollY) {
        const hasVerticalScrollBar = this.verticalScrollBarWidth !== 0;
        this.headerStyleMap = {
          overflowX: 'hidden',
          overflowY: this.scrollY && hasVerticalScrollBar ? 'scroll' : 'hidden'
        };
        this.bodyStyleMap = {
          overflowY: this.scrollY ? 'scroll' : 'hidden',
          overflowX: this.scrollX ? 'auto' : null,
          maxHeight: this.scrollY
        };
        // Caretaker note: we have to emit the value outside the Angular zone, thus DOM timer (`delay(0)`) and `scroll`
        // event listener will be also added outside the Angular zone.
        this.ngZone.runOutsideAngular(() => this.scroll$.next());
      }
      if (data) {
        // See the comment above.
        this.ngZone.runOutsideAngular(() => this.data$.next());
      }
    }
    ngAfterViewInit() {
      if (this.platform.isBrowser) {
        const scrollEvent$ = this.scroll$.pipe(startWith(null), delay(0), switchMap(() => fromEventOutsideAngular(this.tableBodyElement.nativeElement, 'scroll').pipe(startWith(true))));
        const resize$ = this.resizeService.connect();
        merge(scrollEvent$, resize$, this.data$, this.scroll$).pipe(startWith(true), delay(0), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.setScrollPositionClassName());
        scrollEvent$.pipe(filter(() => !!this.scrollY)).subscribe(() => {
          this.tableHeaderElement.nativeElement.scrollLeft = this.tableBodyElement.nativeElement.scrollLeft;
          if (this.tableFootElement) {
            this.tableFootElement.nativeElement.scrollLeft = this.tableBodyElement.nativeElement.scrollLeft;
          }
        });
      }
    }
    static ɵfac = function NzTableInnerScrollComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableInnerScrollComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableInnerScrollComponent,
      selectors: [["nz-table-inner-scroll"]],
      viewQuery: function NzTableInnerScrollComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c10, 5, ElementRef);
          i0.ɵɵviewQuery(_c11, 5, ElementRef);
          i0.ɵɵviewQuery(_c12, 5, ElementRef);
          i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5, CdkVirtualScrollViewport);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableHeaderElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableBodyElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableFootElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkVirtualScrollViewport = _t.first);
        }
      },
      hostAttrs: [1, "ant-table-container"],
      inputs: {
        data: "data",
        scrollX: "scrollX",
        scrollY: "scrollY",
        contentTemplate: "contentTemplate",
        widthConfig: "widthConfig",
        listOfColWidth: "listOfColWidth",
        theadTemplate: "theadTemplate",
        tfootTemplate: "tfootTemplate",
        tfootFixed: "tfootFixed",
        virtualTemplate: "virtualTemplate",
        virtualItemSize: "virtualItemSize",
        virtualMaxBufferPx: "virtualMaxBufferPx",
        virtualMinBufferPx: "virtualMinBufferPx",
        tableMainElement: "tableMainElement",
        virtualForTrackBy: "virtualForTrackBy",
        verticalScrollBarWidth: "verticalScrollBarWidth",
        noDataVirtualHeight: "noDataVirtualHeight"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 1,
      consts: [["tableHeaderElement", ""], ["tableBodyElement", ""], ["tableFootElement", ""], [1, "ant-table-content", 3, "style"], [1, "ant-table-header", "nz-table-hide-scrollbar"], ["nz-table-content", "", "tableLayout", "fixed", 3, "scrollX", "listOfColWidth", "theadTemplate", "tfootTemplate"], [1, "ant-table-body", 3, "style"], [3, "itemSize", "maxBufferPx", "minBufferPx", "height"], [1, "ant-table-summary", 3, "style"], [1, "ant-table-body"], ["nz-table-content", "", "tableLayout", "fixed", 3, "scrollX", "listOfColWidth", "contentTemplate"], [3, "itemSize", "maxBufferPx", "minBufferPx"], ["nz-table-content", "", "tableLayout", "fixed", 3, "scrollX", "listOfColWidth"], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ant-table-summary"], ["nz-table-content", "", "tableLayout", "fixed", 3, "scrollX", "listOfColWidth", "tfootTemplate"], [1, "ant-table-content"], ["nz-table-content", "", "tableLayout", "fixed", 3, "scrollX", "listOfColWidth", "theadTemplate", "contentTemplate", "tfootTemplate"]],
      template: function NzTableInnerScrollComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, NzTableInnerScrollComponent_Conditional_0_Template, 6, 8)(1, NzTableInnerScrollComponent_Conditional_1_Template, 3, 7, "div", 3);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.scrollY ? 0 : 1);
        }
      },
      dependencies: [NzTableContentComponent, ScrollingModule, i1$2.CdkFixedSizeVirtualScroll, i1$2.CdkVirtualForOf, i1$2.CdkVirtualScrollViewport, NgTemplateOutlet, NzTbodyComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableInnerScrollComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableVirtualScrollDirective = /*#__PURE__*/(() => {
  class NzTableVirtualScrollDirective {
    templateRef = inject(TemplateRef);
    static ngTemplateContextGuard(_dir, _ctx) {
      return true;
    }
    static ɵfac = function NzTableVirtualScrollDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableVirtualScrollDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzTableVirtualScrollDirective,
      selectors: [["", "nz-virtual-scroll", ""]],
      exportAs: ["nzVirtualScroll"]
    });
  }
  return NzTableVirtualScrollDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableTitleFooterComponent = /*#__PURE__*/(() => {
  class NzTableTitleFooterComponent {
    title = null;
    footer = null;
    static ɵfac = function NzTableTitleFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableTitleFooterComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableTitleFooterComponent,
      selectors: [["nz-table-title-footer"]],
      hostVars: 4,
      hostBindings: function NzTableTitleFooterComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-title", ctx.title !== null)("ant-table-footer", ctx.footer !== null);
        }
      },
      inputs: {
        title: "title",
        footer: "footer"
      },
      decls: 2,
      vars: 2,
      consts: [[4, "nzStringTemplateOutlet"]],
      template: function NzTableTitleFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NzTableTitleFooterComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, NzTableTitleFooterComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("nzStringTemplateOutlet", ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("nzStringTemplateOutlet", ctx.footer);
        }
      },
      dependencies: [NzOutletModule, i1$3.NzStringTemplateOutletDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTableTitleFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'table';
let NzTableComponent = (() => {
  let _nzLoadingIndicator_decorators;
  let _nzLoadingIndicator_initializers = [];
  let _nzLoadingIndicator_extraInitializers = [];
  let _nzBordered_decorators;
  let _nzBordered_initializers = [];
  let _nzBordered_extraInitializers = [];
  let _nzSize_decorators;
  let _nzSize_initializers = [];
  let _nzSize_extraInitializers = [];
  let _nzShowSizeChanger_decorators;
  let _nzShowSizeChanger_initializers = [];
  let _nzShowSizeChanger_extraInitializers = [];
  let _nzHideOnSinglePage_decorators;
  let _nzHideOnSinglePage_initializers = [];
  let _nzHideOnSinglePage_extraInitializers = [];
  let _nzShowQuickJumper_decorators;
  let _nzShowQuickJumper_initializers = [];
  let _nzShowQuickJumper_extraInitializers = [];
  let _nzSimple_decorators;
  let _nzSimple_initializers = [];
  let _nzSimple_extraInitializers = [];
  return class NzTableComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzLoadingIndicator_decorators = [WithConfig()];
      _nzBordered_decorators = [WithConfig()];
      _nzSize_decorators = [WithConfig()];
      _nzShowSizeChanger_decorators = [WithConfig()];
      _nzHideOnSinglePage_decorators = [WithConfig()];
      _nzShowQuickJumper_decorators = [WithConfig()];
      _nzSimple_decorators = [WithConfig()];
      __esDecorate(null, null, _nzLoadingIndicator_decorators, {
        kind: "field",
        name: "nzLoadingIndicator",
        static: false,
        private: false,
        access: {
          has: obj => "nzLoadingIndicator" in obj,
          get: obj => obj.nzLoadingIndicator,
          set: (obj, value) => {
            obj.nzLoadingIndicator = value;
          }
        },
        metadata: _metadata
      }, _nzLoadingIndicator_initializers, _nzLoadingIndicator_extraInitializers);
      __esDecorate(null, null, _nzBordered_decorators, {
        kind: "field",
        name: "nzBordered",
        static: false,
        private: false,
        access: {
          has: obj => "nzBordered" in obj,
          get: obj => obj.nzBordered,
          set: (obj, value) => {
            obj.nzBordered = value;
          }
        },
        metadata: _metadata
      }, _nzBordered_initializers, _nzBordered_extraInitializers);
      __esDecorate(null, null, _nzSize_decorators, {
        kind: "field",
        name: "nzSize",
        static: false,
        private: false,
        access: {
          has: obj => "nzSize" in obj,
          get: obj => obj.nzSize,
          set: (obj, value) => {
            obj.nzSize = value;
          }
        },
        metadata: _metadata
      }, _nzSize_initializers, _nzSize_extraInitializers);
      __esDecorate(null, null, _nzShowSizeChanger_decorators, {
        kind: "field",
        name: "nzShowSizeChanger",
        static: false,
        private: false,
        access: {
          has: obj => "nzShowSizeChanger" in obj,
          get: obj => obj.nzShowSizeChanger,
          set: (obj, value) => {
            obj.nzShowSizeChanger = value;
          }
        },
        metadata: _metadata
      }, _nzShowSizeChanger_initializers, _nzShowSizeChanger_extraInitializers);
      __esDecorate(null, null, _nzHideOnSinglePage_decorators, {
        kind: "field",
        name: "nzHideOnSinglePage",
        static: false,
        private: false,
        access: {
          has: obj => "nzHideOnSinglePage" in obj,
          get: obj => obj.nzHideOnSinglePage,
          set: (obj, value) => {
            obj.nzHideOnSinglePage = value;
          }
        },
        metadata: _metadata
      }, _nzHideOnSinglePage_initializers, _nzHideOnSinglePage_extraInitializers);
      __esDecorate(null, null, _nzShowQuickJumper_decorators, {
        kind: "field",
        name: "nzShowQuickJumper",
        static: false,
        private: false,
        access: {
          has: obj => "nzShowQuickJumper" in obj,
          get: obj => obj.nzShowQuickJumper,
          set: (obj, value) => {
            obj.nzShowQuickJumper = value;
          }
        },
        metadata: _metadata
      }, _nzShowQuickJumper_initializers, _nzShowQuickJumper_extraInitializers);
      __esDecorate(null, null, _nzSimple_decorators, {
        kind: "field",
        name: "nzSimple",
        static: false,
        private: false,
        access: {
          has: obj => "nzSimple" in obj,
          get: obj => obj.nzSimple,
          set: (obj, value) => {
            obj.nzSimple = value;
          }
        },
        metadata: _metadata
      }, _nzSimple_initializers, _nzSimple_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    _nzModuleName = NZ_CONFIG_MODULE_NAME;
    elementRef = inject(ElementRef);
    nzResizeObserver = inject(NzResizeObserver);
    cdr = inject(ChangeDetectorRef);
    nzTableStyleService = inject(NzTableStyleService);
    nzTableDataService = inject(NzTableDataService);
    directionality = inject(Directionality);
    destroyRef = inject(DestroyRef);
    nzTableLayout = 'auto';
    nzShowTotal = null;
    nzItemRender = null;
    nzTitle = null;
    nzFooter = null;
    nzNoResult = undefined;
    nzPageSizeOptions = [10, 20, 30, 40, 50];
    nzVirtualItemSize = 0;
    nzVirtualMaxBufferPx = 200;
    nzVirtualMinBufferPx = 100;
    nzVirtualForTrackBy = index => index;
    nzLoadingDelay = 0;
    nzPageIndex = 1;
    nzPageSize = 10;
    nzTotal = 0;
    nzWidthConfig = [];
    nzData = [];
    nzCustomColumn = [];
    nzPaginationPosition = 'bottom';
    nzScroll = {
      x: null,
      y: null
    };
    noDataVirtualHeight = '182px';
    nzPaginationType = 'default';
    nzFrontPagination = true;
    nzTemplateMode = false;
    nzShowPagination = true;
    nzLoading = false;
    nzOuterBordered = false;
    nzLoadingIndicator = __runInitializers(this, _nzLoadingIndicator_initializers, null);
    nzBordered = (__runInitializers(this, _nzLoadingIndicator_extraInitializers), __runInitializers(this, _nzBordered_initializers, false));
    nzSize = (__runInitializers(this, _nzBordered_extraInitializers), __runInitializers(this, _nzSize_initializers, 'default'));
    nzShowSizeChanger = (__runInitializers(this, _nzSize_extraInitializers), __runInitializers(this, _nzShowSizeChanger_initializers, false));
    nzHideOnSinglePage = (__runInitializers(this, _nzShowSizeChanger_extraInitializers), __runInitializers(this, _nzHideOnSinglePage_initializers, false));
    nzShowQuickJumper = (__runInitializers(this, _nzHideOnSinglePage_extraInitializers), __runInitializers(this, _nzShowQuickJumper_initializers, false));
    nzSimple = (__runInitializers(this, _nzShowQuickJumper_extraInitializers), __runInitializers(this, _nzSimple_initializers, false));
    nzPageSizeChange = (__runInitializers(this, _nzSimple_extraInitializers), new EventEmitter());
    nzPageIndexChange = new EventEmitter();
    nzQueryParams = new EventEmitter();
    nzCurrentPageDataChange = new EventEmitter();
    nzCustomColumnChange = new EventEmitter();
    /** public data for ngFor tr */
    data = [];
    cdkVirtualScrollViewport;
    scrollX = null;
    scrollY = null;
    theadTemplate = null;
    tfootTemplate = null;
    tfootFixed = null;
    listOfAutoColWidth = [];
    listOfManualColWidth = [];
    hasFixLeft = false;
    hasFixRight = false;
    showPagination = true;
    templateMode$ = new BehaviorSubject(false);
    dir = 'ltr';
    nzVirtualScrollDirective;
    nzTableInnerScrollComponent;
    verticalScrollBarWidth = 0;
    onPageSizeChange(size) {
      this.nzTableDataService.updatePageSize(size);
    }
    onPageIndexChange(index) {
      this.nzTableDataService.updatePageIndex(index);
    }
    constructor() {
      onConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME, () => this.cdr.markForCheck());
    }
    ngOnInit() {
      const {
        pageIndexDistinct$,
        pageSizeDistinct$,
        listOfCurrentPageData$,
        total$,
        queryParams$,
        listOfCustomColumn$
      } = this.nzTableDataService;
      const {
        theadTemplate$,
        tfootTemplate$,
        tfootFixed$,
        hasFixLeft$,
        hasFixRight$
      } = this.nzTableStyleService;
      this.dir = this.directionality.value;
      this.directionality.change?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      queryParams$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.nzQueryParams);
      pageIndexDistinct$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(pageIndex => {
        if (pageIndex !== this.nzPageIndex) {
          this.nzPageIndex = pageIndex;
          this.nzPageIndexChange.next(pageIndex);
        }
      });
      pageSizeDistinct$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(pageSize => {
        if (pageSize !== this.nzPageSize) {
          this.nzPageSize = pageSize;
          this.nzPageSizeChange.next(pageSize);
        }
      });
      total$.pipe(takeUntilDestroyed(this.destroyRef), filter(total => this.nzFrontPagination && total !== this.nzTotal)).subscribe(total => {
        this.nzTotal = total;
        this.cdr.markForCheck();
      });
      listOfCurrentPageData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        this.data = data;
        this.nzCurrentPageDataChange.next(data);
        this.cdr.markForCheck();
      });
      listOfCustomColumn$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        this.nzCustomColumn = data;
        this.nzCustomColumnChange.next(data);
        this.cdr.markForCheck();
      });
      theadTemplate$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(theadTemplate => {
        this.theadTemplate = theadTemplate;
        this.cdr.markForCheck();
      });
      combineLatest([tfootTemplate$, tfootFixed$]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([tfootTemplate, tfootFixed]) => {
        this.tfootTemplate = tfootTemplate;
        this.tfootFixed = tfootFixed;
        this.cdr.markForCheck();
      });
      hasFixLeft$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasFixLeft => {
        this.hasFixLeft = hasFixLeft;
        this.cdr.markForCheck();
      });
      hasFixRight$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasFixRight => {
        this.hasFixRight = hasFixRight;
        this.cdr.markForCheck();
      });
      combineLatest([total$, this.templateMode$]).pipe(map(([total, templateMode]) => total === 0 && !templateMode), takeUntilDestroyed(this.destroyRef)).subscribe(empty => {
        this.nzTableStyleService.setShowEmpty(empty);
      });
      this.verticalScrollBarWidth = measureScrollbar('vertical');
      this.nzTableStyleService.listOfListOfThWidthPx$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(listOfWidth => {
        this.listOfAutoColWidth = listOfWidth;
        this.cdr.markForCheck();
      });
      this.nzTableStyleService.manualWidthConfigPx$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(listOfWidth => {
        this.listOfManualColWidth = listOfWidth;
        this.cdr.markForCheck();
      });
    }
    ngOnChanges(changes) {
      const {
        nzScroll,
        nzPageIndex,
        nzPageSize,
        nzFrontPagination,
        nzData,
        nzCustomColumn,
        nzWidthConfig,
        nzNoResult,
        nzTemplateMode
      } = changes;
      if (nzPageIndex) {
        this.nzTableDataService.updatePageIndex(this.nzPageIndex);
      }
      if (nzPageSize) {
        this.nzTableDataService.updatePageSize(this.nzPageSize);
      }
      if (nzData) {
        this.nzData = this.nzData || [];
        this.nzTableDataService.updateListOfData(this.nzData);
      }
      if (nzCustomColumn) {
        this.nzCustomColumn = this.nzCustomColumn || [];
        this.nzTableDataService.updateListOfCustomColumn(this.nzCustomColumn);
      }
      if (nzFrontPagination) {
        this.nzTableDataService.updateFrontPagination(this.nzFrontPagination);
      }
      if (nzScroll) {
        this.setScrollOnChanges();
      }
      if (nzWidthConfig) {
        this.nzTableStyleService.setTableWidthConfig(this.nzWidthConfig);
      }
      if (nzTemplateMode) {
        this.templateMode$.next(this.nzTemplateMode);
      }
      if (nzNoResult) {
        this.nzTableStyleService.setNoResult(this.nzNoResult);
      }
      this.updateShowPagination();
    }
    ngAfterViewInit() {
      this.nzResizeObserver.observe(this.elementRef).pipe(map(([entry]) => {
        const {
          width
        } = entry.target.getBoundingClientRect();
        const scrollBarWidth = this.scrollY ? this.verticalScrollBarWidth : 0;
        return Math.floor(width - scrollBarWidth);
      }), takeUntilDestroyed(this.destroyRef)).subscribe(this.nzTableStyleService.hostWidth$);
      if (this.nzTableInnerScrollComponent && this.nzTableInnerScrollComponent.cdkVirtualScrollViewport) {
        this.cdkVirtualScrollViewport = this.nzTableInnerScrollComponent.cdkVirtualScrollViewport;
      }
    }
    setScrollOnChanges() {
      this.scrollX = this.nzScroll && this.nzScroll.x || null;
      this.scrollY = this.nzScroll && this.nzScroll.y || null;
      this.nzTableStyleService.setScroll(this.scrollX, this.scrollY);
    }
    updateShowPagination() {
      this.showPagination = this.nzHideOnSinglePage && this.nzData.length > this.nzPageSize || this.nzData.length > 0 && !this.nzHideOnSinglePage || !this.nzFrontPagination && this.nzTotal > this.nzPageSize;
    }
    static ɵfac = function NzTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTableComponent,
      selectors: [["nz-table"]],
      contentQueries: function NzTableComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NzTableVirtualScrollDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nzVirtualScrollDirective = _t.first);
        }
      },
      viewQuery: function NzTableComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NzTableInnerScrollComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nzTableInnerScrollComponent = _t.first);
        }
      },
      hostAttrs: [1, "ant-table-wrapper"],
      hostVars: 4,
      hostBindings: function NzTableComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-wrapper-rtl", ctx.dir === "rtl")("ant-table-custom-column", ctx.nzCustomColumn.length);
        }
      },
      inputs: {
        nzTableLayout: "nzTableLayout",
        nzShowTotal: "nzShowTotal",
        nzItemRender: "nzItemRender",
        nzTitle: "nzTitle",
        nzFooter: "nzFooter",
        nzNoResult: "nzNoResult",
        nzPageSizeOptions: "nzPageSizeOptions",
        nzVirtualItemSize: "nzVirtualItemSize",
        nzVirtualMaxBufferPx: "nzVirtualMaxBufferPx",
        nzVirtualMinBufferPx: "nzVirtualMinBufferPx",
        nzVirtualForTrackBy: "nzVirtualForTrackBy",
        nzLoadingDelay: "nzLoadingDelay",
        nzPageIndex: "nzPageIndex",
        nzPageSize: "nzPageSize",
        nzTotal: "nzTotal",
        nzWidthConfig: "nzWidthConfig",
        nzData: "nzData",
        nzCustomColumn: "nzCustomColumn",
        nzPaginationPosition: "nzPaginationPosition",
        nzScroll: "nzScroll",
        noDataVirtualHeight: "noDataVirtualHeight",
        nzPaginationType: "nzPaginationType",
        nzFrontPagination: [2, "nzFrontPagination", "nzFrontPagination", booleanAttribute],
        nzTemplateMode: [2, "nzTemplateMode", "nzTemplateMode", booleanAttribute],
        nzShowPagination: [2, "nzShowPagination", "nzShowPagination", booleanAttribute],
        nzLoading: [2, "nzLoading", "nzLoading", booleanAttribute],
        nzOuterBordered: [2, "nzOuterBordered", "nzOuterBordered", booleanAttribute],
        nzLoadingIndicator: "nzLoadingIndicator",
        nzBordered: [2, "nzBordered", "nzBordered", booleanAttribute],
        nzSize: "nzSize",
        nzShowSizeChanger: [2, "nzShowSizeChanger", "nzShowSizeChanger", booleanAttribute],
        nzHideOnSinglePage: [2, "nzHideOnSinglePage", "nzHideOnSinglePage", booleanAttribute],
        nzShowQuickJumper: [2, "nzShowQuickJumper", "nzShowQuickJumper", booleanAttribute],
        nzSimple: [2, "nzSimple", "nzSimple", booleanAttribute]
      },
      outputs: {
        nzPageSizeChange: "nzPageSizeChange",
        nzPageIndexChange: "nzPageIndexChange",
        nzQueryParams: "nzQueryParams",
        nzCurrentPageDataChange: "nzCurrentPageDataChange",
        nzCustomColumnChange: "nzCustomColumnChange"
      },
      exportAs: ["nzTable"],
      features: [i0.ɵɵProvidersFeature([NzTableStyleService, NzTableDataService]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 13,
      vars: 26,
      consts: [["tableMainElement", ""], ["paginationTemplate", ""], ["contentTemplate", ""], [3, "nzDelay", "nzSpinning", "nzIndicator"], [3, "ngTemplateOutlet"], [1, "ant-table"], [3, "title"], [3, "data", "scrollX", "scrollY", "contentTemplate", "listOfColWidth", "theadTemplate", "tfootTemplate", "tfootFixed", "verticalScrollBarWidth", "virtualTemplate", "virtualItemSize", "virtualMaxBufferPx", "virtualMinBufferPx", "tableMainElement", "virtualForTrackBy", "noDataVirtualHeight"], [3, "tableLayout", "listOfColWidth", "theadTemplate", "contentTemplate", "tfootTemplate"], [3, "footer"], [1, "ant-table-pagination", "ant-table-pagination-right", 3, "hidden", "nzShowSizeChanger", "nzPageSizeOptions", "nzItemRender", "nzShowQuickJumper", "nzHideOnSinglePage", "nzShowTotal", "nzSize", "nzPageSize", "nzTotal", "nzSimple", "nzPageIndex"], [1, "ant-table-pagination", "ant-table-pagination-right", 3, "nzPageSizeChange", "nzPageIndexChange", "hidden", "nzShowSizeChanger", "nzPageSizeOptions", "nzItemRender", "nzShowQuickJumper", "nzHideOnSinglePage", "nzShowTotal", "nzSize", "nzPageSize", "nzTotal", "nzSimple", "nzPageIndex"]],
      template: function NzTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "nz-spin", 3);
          i0.ɵɵconditionalCreate(1, NzTableComponent_Conditional_1_Template, 1, 1, null, 4);
          i0.ɵɵelementStart(2, "div", 5, 0);
          i0.ɵɵconditionalCreate(4, NzTableComponent_Conditional_4_Template, 1, 1, "nz-table-title-footer", 6);
          i0.ɵɵconditionalCreate(5, NzTableComponent_Conditional_5_Template, 1, 16, "nz-table-inner-scroll", 7)(6, NzTableComponent_Conditional_6_Template, 1, 5, "nz-table-inner-default", 8);
          i0.ɵɵconditionalCreate(7, NzTableComponent_Conditional_7_Template, 1, 1, "nz-table-title-footer", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵconditionalCreate(8, NzTableComponent_Conditional_8_Template, 1, 1, null, 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, NzTableComponent_ng_template_9_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, NzTableComponent_ng_template_11_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("nzDelay", ctx.nzLoadingDelay)("nzSpinning", ctx.nzLoading)("nzIndicator", ctx.nzLoadingIndicator);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzPaginationPosition === "both" || ctx.nzPaginationPosition === "top" ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("ant-table-rtl", ctx.dir === "rtl")("ant-table-fixed-header", ctx.nzData.length && ctx.scrollY)("ant-table-fixed-column", ctx.scrollX)("ant-table-has-fix-left", ctx.hasFixLeft)("ant-table-has-fix-right", ctx.hasFixRight)("ant-table-bordered", ctx.nzBordered)("nz-table-out-bordered", ctx.nzOuterBordered && !ctx.nzBordered)("ant-table-middle", ctx.nzSize === "middle")("ant-table-small", ctx.nzSize === "small");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.nzTitle ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.scrollY || ctx.scrollX ? 5 : 6);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.nzFooter ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzPaginationPosition === "both" || ctx.nzPaginationPosition === "bottom" ? 8 : -1);
        }
      },
      dependencies: [NzSpinComponent, NgTemplateOutlet, NzTableTitleFooterComponent, NzTableInnerScrollComponent, NzTableInnerDefaultComponent, NzPaginationModule, i1$4.NzPaginationComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function fixedAttribute(value) {
  return value === 'top' || value === 'bottom' ? value : booleanAttribute(value) ? 'bottom' : null;
}
/* eslint-disable @angular-eslint/component-selector */
let NzTfootSummaryComponent = /*#__PURE__*/(() => {
  class NzTfootSummaryComponent {
    nzFixed = null;
    templateRef;
    nzTableStyleService = inject(NzTableStyleService, {
      optional: true
    });
    isInsideTable = !!this.nzTableStyleService;
    ngOnInit() {
      this.nzTableStyleService?.setTfootTemplate(this.templateRef);
    }
    ngOnChanges(changes) {
      const {
        nzFixed
      } = changes;
      this.nzTableStyleService?.setTfootFixed(nzFixed.currentValue);
    }
    static ɵfac = function NzTfootSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTfootSummaryComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTfootSummaryComponent,
      selectors: [["tfoot", "nzSummary", ""]],
      viewQuery: function NzTfootSummaryComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c14, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function NzTfootSummaryComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-summary", !ctx.isInsideTable || !ctx.nzFixed);
        }
      },
      inputs: {
        nzFixed: [2, "nzFixed", "nzFixed", fixedAttribute]
      },
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c15,
      ngContentSelectors: _c0,
      decls: 3,
      vars: 1,
      consts: [["contentTemplate", ""], [3, "ngTemplateOutlet"]],
      template: function NzTfootSummaryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NzTfootSummaryComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵconditionalCreate(2, NzTfootSummaryComponent_Conditional_2_Template, 1, 1, null, 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.isInsideTable || !ctx.nzFixed ? 2 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTfootSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTrDirective = /*#__PURE__*/(() => {
  class NzTrDirective {
    destroyRef = inject(DestroyRef);
    listOfNzThDirective;
    listOfCellFixedDirective;
    listOfFixedColumns$ = new ReplaySubject(1);
    listOfColumns$ = new ReplaySubject(1);
    listOfFixedColumnsChanges$ = this.listOfFixedColumns$.pipe(switchMap(list => merge(this.listOfFixedColumns$, ...list.map(c => c.changes$)).pipe(mergeMap(() => this.listOfFixedColumns$))), takeUntilDestroyed(this.destroyRef));
    listOfFixedLeftColumnChanges$ = this.listOfFixedColumnsChanges$.pipe(map(list => list.filter(item => item.nzLeft !== false)));
    listOfFixedRightColumnChanges$ = this.listOfFixedColumnsChanges$.pipe(map(list => list.filter(item => item.nzRight !== false)));
    listOfColumnsChanges$ = this.listOfColumns$.pipe(switchMap(list => merge(this.listOfColumns$, ...list.map(c => c.changes$)).pipe(mergeMap(() => this.listOfColumns$))), takeUntilDestroyed(this.destroyRef));
    nzTableStyleService = inject(NzTableStyleService, {
      optional: true
    });
    isInsideTable = !!this.nzTableStyleService;
    ngAfterContentInit() {
      if (this.nzTableStyleService) {
        this.listOfCellFixedDirective.changes.pipe(startWith(this.listOfCellFixedDirective), takeUntilDestroyed(this.destroyRef)).subscribe(this.listOfFixedColumns$);
        this.listOfNzThDirective.changes.pipe(startWith(this.listOfNzThDirective), takeUntilDestroyed(this.destroyRef)).subscribe(this.listOfColumns$);
        /** set last left and first right **/
        this.listOfFixedLeftColumnChanges$.subscribe(listOfFixedLeft => {
          listOfFixedLeft.forEach(cell => cell.setIsLastLeft(cell === listOfFixedLeft[listOfFixedLeft.length - 1]));
        });
        this.listOfFixedRightColumnChanges$.subscribe(listOfFixedRight => {
          listOfFixedRight.forEach(cell => cell.setIsFirstRight(cell === listOfFixedRight[0]));
        });
        /** calculate fixed nzLeft and nzRight **/
        combineLatest([this.nzTableStyleService.listOfListOfThWidth$, this.listOfFixedLeftColumnChanges$]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([listOfAutoWidth, listOfLeftCell]) => {
          listOfLeftCell.forEach((cell, index) => {
            if (cell.isAutoLeft) {
              const currentArray = listOfLeftCell.slice(0, index);
              const count = currentArray.reduce((pre, cur) => pre + (cur.colspan || cur.colSpan || 1), 0);
              const width = listOfAutoWidth.slice(0, count).reduce((pre, cur) => pre + cur, 0);
              cell.setAutoLeftWidth(`${width}px`);
            }
          });
        });
        combineLatest([this.nzTableStyleService.listOfListOfThWidth$, this.listOfFixedRightColumnChanges$]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([listOfAutoWidth, listOfRightCell]) => {
          listOfRightCell.forEach((_, index) => {
            const cell = listOfRightCell[listOfRightCell.length - index - 1];
            if (cell.isAutoRight) {
              const currentArray = listOfRightCell.slice(listOfRightCell.length - index, listOfRightCell.length);
              const count = currentArray.reduce((pre, cur) => pre + (cur.colspan || cur.colSpan || 1), 0);
              const width = listOfAutoWidth.slice(listOfAutoWidth.length - count, listOfAutoWidth.length).reduce((pre, cur) => pre + cur, 0);
              cell.setAutoRightWidth(`${width}px`);
            }
          });
        });
      }
    }
    static ɵfac = function NzTrDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTrDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzTrDirective,
      selectors: [["tr", 3, "nz-table-measure-row", "", 3, "nzExpand", "", 3, "nz-table-fixed-row", ""]],
      contentQueries: function NzTrDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NzThMeasureDirective, 4);
          i0.ɵɵcontentQuery(dirIndex, NzCellFixedDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfNzThDirective = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfCellFixedDirective = _t);
        }
      },
      hostVars: 2,
      hostBindings: function NzTrDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-table-row", ctx.isInsideTable);
        }
      }
    });
  }
  return NzTrDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/* eslint-disable @angular-eslint/component-selector */
let NzTheadComponent = /*#__PURE__*/(() => {
  class NzTheadComponent {
    nzTableStyleService = inject(NzTableStyleService, {
      optional: true
    });
    nzTableDataService = inject(NzTableDataService, {
      optional: true
    });
    destroyRef = inject(DestroyRef);
    el = inject(ElementRef).nativeElement;
    renderer = inject(Renderer2);
    isInsideTable = !!this.nzTableStyleService;
    templateRef;
    listOfNzTrDirective;
    listOfNzThAddOnComponent;
    nzSortOrderChange = new EventEmitter();
    ngOnInit() {
      if (this.nzTableStyleService) {
        this.nzTableStyleService.setTheadTemplate(this.templateRef);
      }
    }
    ngAfterContentInit() {
      if (this.nzTableStyleService) {
        const firstTableRow$ = this.listOfNzTrDirective.changes.pipe(startWith(this.listOfNzTrDirective), map(item => item && item.first), takeUntilDestroyed(this.destroyRef));
        const listOfColumnsChanges$ = firstTableRow$.pipe(switchMap(firstTableRow => firstTableRow ? firstTableRow.listOfColumnsChanges$ : EMPTY));
        listOfColumnsChanges$.subscribe(data => this.nzTableStyleService.setListOfTh(data));
        /** TODO: need reset the measure row when scrollX change **/
        this.nzTableStyleService.enableAutoMeasure$.pipe(switchMap(enable => enable ? listOfColumnsChanges$ : of([]))).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => this.nzTableStyleService.setListOfMeasureColumn(data));
        const listOfFixedLeftColumnChanges$ = firstTableRow$.pipe(switchMap(firstTr => firstTr ? firstTr.listOfFixedLeftColumnChanges$ : EMPTY));
        const listOfFixedRightColumnChanges$ = firstTableRow$.pipe(switchMap(firstTr => firstTr ? firstTr.listOfFixedRightColumnChanges$ : EMPTY));
        listOfFixedLeftColumnChanges$.subscribe(listOfFixedLeftColumn => {
          this.nzTableStyleService.setHasFixLeft(listOfFixedLeftColumn.length !== 0);
        });
        listOfFixedRightColumnChanges$.subscribe(listOfFixedRightColumn => {
          this.nzTableStyleService.setHasFixRight(listOfFixedRightColumn.length !== 0);
        });
      }
      if (this.nzTableDataService) {
        const listOfColumn$ = this.listOfNzThAddOnComponent.changes.pipe(startWith(this.listOfNzThAddOnComponent));
        const manualSort$ = listOfColumn$.pipe(switchMap(() => merge(...this.listOfNzThAddOnComponent.map(th => th.manualClickOrder$))), takeUntilDestroyed(this.destroyRef));
        manualSort$.subscribe(data => {
          const emitValue = {
            key: data.nzColumnKey,
            value: data.sortOrder
          };
          this.nzSortOrderChange.emit(emitValue);
          if (data.nzSortFn && data.nzSortPriority === false) {
            this.listOfNzThAddOnComponent.filter(th => th !== data).forEach(th => th.clearSortOrder());
          }
        });
        const listOfCalcOperator$ = listOfColumn$.pipe(switchMap(list => merge(listOfColumn$, ...list.map(c => c.calcOperatorChange$)).pipe(mergeMap(() => listOfColumn$))), map(list => list.filter(item => !!item.nzSortFn || !!item.nzFilterFn).map(item => {
          const {
            nzSortFn,
            sortOrder,
            nzFilterFn,
            nzFilterValue,
            nzSortPriority,
            nzColumnKey
          } = item;
          return {
            key: nzColumnKey,
            sortFn: nzSortFn,
            sortPriority: nzSortPriority,
            sortOrder: sortOrder,
            filterFn: nzFilterFn,
            filterValue: nzFilterValue
          };
        })),
        // TODO: after checked error here
        delay(0), takeUntilDestroyed(this.destroyRef));
        listOfCalcOperator$.subscribe(list => {
          this.nzTableDataService?.listOfCalcOperator$.next(list);
        });
      }
    }
    ngAfterViewInit() {
      if (this.nzTableStyleService) {
        this.renderer.removeChild(this.renderer.parentNode(this.el), this.el);
      }
    }
    static ɵfac = function NzTheadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTheadComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTheadComponent,
      selectors: [["thead", 9, "ant-table-thead"]],
      contentQueries: function NzTheadComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NzTrDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, NzThAddOnComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfNzTrDirective = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfNzThAddOnComponent = _t);
        }
      },
      viewQuery: function NzTheadComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c14, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        }
      },
      outputs: {
        nzSortOrderChange: "nzSortOrderChange"
      },
      ngContentSelectors: _c0,
      decls: 3,
      vars: 1,
      consts: [["contentTemplate", ""], [3, "ngTemplateOutlet"]],
      template: function NzTheadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NzTheadComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵconditionalCreate(2, NzTheadComponent_Conditional_2_Template, 1, 1, null, 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.isInsideTable ? 2 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTheadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTrExpandDirective = /*#__PURE__*/(() => {
  class NzTrExpandDirective {
    nzExpand = true;
    static ɵfac = function NzTrExpandDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTrExpandDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzTrExpandDirective,
      selectors: [["tr", "nzExpand", ""]],
      hostAttrs: [1, "ant-table-expanded-row"],
      hostVars: 1,
      hostBindings: function NzTrExpandDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵdomProperty("hidden", !ctx.nzExpand);
        }
      },
      inputs: {
        nzExpand: [2, "nzExpand", "nzExpand", booleanAttribute]
      }
    });
  }
  return NzTrExpandDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTableModule = /*#__PURE__*/(() => {
  class NzTableModule {
    static ɵfac = function NzTableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTableModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzTableModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NzTableComponent, NzThAddOnComponent, NzTdAddOnComponent, NzTbodyComponent, NzTableTitleFooterComponent, NzTableInnerScrollComponent, NzTableSortersComponent, NzTableFilterComponent, NzTableSelectionComponent, NzFilterTriggerComponent, NzThSelectionComponent]
    });
  }
  return NzTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzCellAlignDirective, NzCellBreakWordDirective, NzCellEllipsisDirective, NzCellFixedDirective, NzCustomColumnDirective, NzFilterTriggerComponent, NzRowExpandButtonDirective, NzRowIndentDirective, NzTableCellDirective, NzTableComponent, NzTableContentComponent, NzTableDataService, NzTableFilterComponent, NzTableFixedRowComponent, NzTableInnerDefaultComponent, NzTableInnerScrollComponent, NzTableModule, NzTableSelectionComponent, NzTableSortersComponent, NzTableStyleService, NzTableTitleFooterComponent, NzTableVirtualScrollDirective, NzTbodyComponent, NzTdAddOnComponent, NzTfootSummaryComponent, NzThAddOnComponent, NzThMeasureDirective, NzThSelectionComponent, NzTheadComponent, NzTrDirective, NzTrExpandDirective, NzTrMeasureComponent };
